import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { FaSearch, FaUsers, FaTimes, FaUserFriends, FaIdCard, FaLink, FaFileAlt, FaFileContract, FaEye, FaEdit, FaSave, FaTrash, FaUser, FaCalendarCheck, FaMoneyBillWave, FaUserPlus, FaBan, FaUndo } from "react-icons/fa";
import "../../css/Suscriptores.css";

const baseURL = process.env.REACT_APP_API_BASE_URL;
const API = `${baseURL}/api/Suscriptores`;

const Suscriptores = () => {
  const cookies = new Cookies();

  // ── Estado ──────────────────────────────────────────────────────────────────
  const [datos, setDatos] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroPlan, setFiltroPlan] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroPrimerPagoDesde, setFiltroPrimerPagoDesde] = useState("");
  const [filtroPrimerPagoHasta, setFiltroPrimerPagoHasta] = useState("");
  const [filtroTipoFecha, setFiltroTipoFecha] = useState("");
  const [paginaActual, setPaginaActual] = useState(1);
  const [loading, setLoading] = useState(false);
  const [planesUnicos, setPlanesUnicos] = useState([]);

  // Modal beneficiarios
  const [modalBenef, setModalBenef] = useState(false);
  const [suscriptorActivo, setSuscriptorActivo] = useState(null);
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [loadingBenef, setLoadingBenef] = useState(false);
  const [benefFormMode, setBenefFormMode] = useState(null); // null | "crear" | id_beneficiario
  const [benefFormData, setBenefFormData] = useState({});
  const [savingBenef, setSavingBenef] = useState(false);
  const [consumosGMF, setConsumosGMF] = useState({});

  // Modal citas consumidas / detalle GMF (unificado)
  const [modalCitasGmf, setModalCitasGmf] = useState(false);
  const [suscCitasGmfActivo, setSuscCitasGmfActivo] = useState(null);
  const [loadingCitasGmf, setLoadingCitasGmf] = useState(false);
  const [conteoCitasGmf, setConteoCitasGmf] = useState(null);
  const [citasGmfDetalle, setCitasGmfDetalle] = useState(null);

  // Modal documentos
  const [modalDocs, setModalDocs] = useState(false);
  const [documentos, setDocumentos] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [suscDocActivo, setSuscDocActivo] = useState(null);
  const [tabActivo, setTabActivo] = useState("documentos");

  // Modal detalle
  const [modalDetalle, setModalDetalle] = useState(false);
  const [suscDetalleActivo, setSuscDetalleActivo] = useState(null);
  const [detalleTab, setDetalleTab] = useState("info");

  // Edición
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({});
  const [saving, setSaving] = useState(false);

  // Modal acudiente
  const [acudientes, setAcudientes] = useState([]);
  const [loadingAcudiente, setLoadingAcudiente] = useState(false);

  // Modal pago de N meses
  const [modalPagoMeses, setModalPagoMeses] = useState(false);
  const [suscPagoMesesActivo, setSuscPagoMesesActivo] = useState(null);
  const [mesesAPagar, setMesesAPagar] = useState(1);
  const [mesesYaPagados, setMesesYaPagados] = useState(0);
  const [medioPagoMeses, setMedioPagoMeses] = useState("EFECTIVO");
  const [valorPlanMensual, setValorPlanMensual] = useState(0);
  const [valorPlanAnual, setValorPlanAnual] = useState(0);
  const [loadingPagoMeses, setLoadingPagoMeses] = useState(false);
  const [procesandoPagoMeses, setProcesandoPagoMeses] = useState(false);

  // Modal finalizar / renovar suscripción
  const [modalFinalizar, setModalFinalizar] = useState(false);
  const [suscFinalizarActivo, setSuscFinalizarActivo] = useState(null);
  const [loadingFinalizar, setLoadingFinalizar] = useState(false);
  const [procesandoFinalizar, setProcesandoFinalizar] = useState(false);
  const [deseaRenovar, setDeseaRenovar] = useState(null); // null | true | false
  const [frecuenciaRenovacion, setFrecuenciaRenovacion] = useState("MENSUAL");
  const [valorPlanRenovMensual, setValorPlanRenovMensual] = useState(0);
  const [valorPlanRenovAnual, setValorPlanRenovAnual] = useState(0);
  const [mesesRenovAPagar, setMesesRenovAPagar] = useState(1);
  const [medioPagoRenov, setMedioPagoRenov] = useState("EFECTIVO");
  const [soloRenovar, setSoloRenovar] = useState(false); // true: se abrió desde "Ver Detalle" sobre una suscripción ya FINALIZADA

  const elementosPorPagina = 10;

  // ── Fetch suscriptores ───────────────────────────────────────────────────────
  const fetchSuscriptores = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/ObtenerSuscriptores`);
      const lista = res.data?.data || res.data || [];
      setDatos(lista);
      const planes = [...new Set(lista.map((s) => s.nombre_plan).filter(Boolean))];
      setPlanesUnicos(planes);
      setPaginaActual(1);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error al cargar suscriptores", text: "Intenta nuevamente." });
    } finally {
      setLoading(false);
    }
  }, []);

  // ── Filtrado reactivo ────────────────────────────────────────────────────────
  useEffect(() => {
    const q = busqueda.trim().toLowerCase();
    const filtrados = datos.filter((s) => {
      const coincideBusqueda =
        !q ||
        s.nombresApellidos?.toLowerCase().includes(q) ||
        s.documento?.toLowerCase().includes(q) ||
        s.celular?.toLowerCase().includes(q) ||
        s.email?.toLowerCase().includes(q) ||
        s.codigo_asesor?.toLowerCase().includes(q);
      const coincidePlan = !filtroPlan || s.nombre_plan === filtroPlan;
      const coincideEstado = !filtroEstado || s.estado_suscripcion === filtroEstado;

      let coincideFecha = true;
      if (filtroTipoFecha === "primer_pago" && (filtroPrimerPagoDesde || filtroPrimerPagoHasta)) {
        const fecha = s.primer_pago ? parsearFechaLocal(s.primer_pago) : null;
        if (!fecha) { coincideFecha = false; }
        if (coincideFecha && filtroPrimerPagoDesde && fecha < parsearFechaLocal(filtroPrimerPagoDesde)) { coincideFecha = false; }
        if (coincideFecha && filtroPrimerPagoHasta && fecha > parsearFechaLocal(filtroPrimerPagoHasta)) { coincideFecha = false; }
      }
      if (filtroTipoFecha === "cobertura" && (filtroPrimerPagoDesde || filtroPrimerPagoHasta)) {
        const ini = s.fecha_inicio_cobertura ? parsearFechaLocal(s.fecha_inicio_cobertura) : null;
        const fin = s.fecha_fin_cobertura ? parsearFechaLocal(s.fecha_fin_cobertura) : null;
        const desde = filtroPrimerPagoDesde ? parsearFechaLocal(filtroPrimerPagoDesde) : null;
        const hasta = filtroPrimerPagoHasta ? parsearFechaLocal(filtroPrimerPagoHasta) : null;
        if (desde && (!fin || fin < desde)) { coincideFecha = false; }
        if (hasta && (!ini || ini > hasta)) { coincideFecha = false; }
      }

      return coincideBusqueda && coincidePlan && coincideEstado && coincideFecha;
    });
    setDatosFiltrados(filtrados);
    setPaginaActual(1);
  }, [datos, busqueda, filtroPlan, filtroEstado, filtroPrimerPagoDesde, filtroPrimerPagoHasta, filtroTipoFecha]);

  useEffect(() => { fetchSuscriptores(); }, [fetchSuscriptores]);

  // ── Beneficiarios ────────────────────────────────────────────────────────────
  const verBeneficiarios = async (suscriptor) => {
    setSuscriptorActivo(suscriptor);
    setBeneficiarios([]);
    setConsumosGMF({});
    setModalBenef(true);
    setLoadingBenef(true);
    try {
      const res = await axios.get(`${API}/ObtenerBeneficiarios`, {
        params: { suscriptor_id: suscriptor.id_suscriptor }
      });
      const lista = res.data?.data || res.data || [];
      setBeneficiarios(lista);
      cargarConsumosGMF(lista, suscriptor);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error al cargar beneficiarios", text: "Intenta nuevamente." });
    } finally {
      setLoadingBenef(false);
    }
  };

  // ── Consumos Tarjeta GMF (backend appgmfapi / citas) ────────────────────────
  // Valida o crea el paciente para un beneficiario nuevo y devuelve su idPaciente.
  const validarOCrearPaciente = async (datos, suscripcionId) => {
    const token = await obtenerTokenCitas();
    const res = await citasAxios.post(
      `${CITAS_API_BASE}/paciente/ValidarOCrearPaciente`,
      {
        numId: datos.numero_documento,
        nombre1: datos.nombres,
        nombre2: "",
        apellido1: datos.apellidos,
        apellido2: "",
        estCivil: "",
        tipoId: datos.tipo_documento,
        correo: datos.email,
        telefono: datos.telefono,
        suscripcionId: String(suscripcionId),
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const idPaciente = res.data?.idPaciente ?? res.data?.data?.idPaciente;
    if (!idPaciente) throw new Error("No se obtuvo idPaciente.");
    return idPaciente;
  };

  // Sincroniza el estado de la suscripción GMF del paciente.
  // suscripcionId = null cuando se inactiva; el id de la suscripción cuando se activa.
  const actualizarSuscripcionGMF = async (pacienteId, suscripcionId) => {
    const token = await obtenerTokenCitas();
    await citasAxios.post(
      `${CITAS_API_BASE}/paciente/ActualizarSuscripcionGMF`,
      {
        pacienteId: String(pacienteId),
        suscripcionId: suscripcionId == null ? null : String(suscripcionId),
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  const cargarConsumosGMF = async (lista, suscriptor) => {
    const conPaciente = lista.filter((b) => b.paciente_id);
    if (conPaciente.length === 0) return;

    setConsumosGMF((prev) => {
      const next = { ...prev };
      conPaciente.forEach((b) => { next[b.id_beneficiario] = { loading: true }; });
      return next;
    });

    try {
      const token = await obtenerTokenCitas();
      const resultados = await Promise.all(
        conPaciente.map(async (b) => {
          try {
            const res = await citasAxios.post(
              `${CITAS_API_BASE}/citas/ConsumosTarjetaGmf`,
              { pacienteId: b.paciente_id, FechaInicioSuscripcion: suscriptor?.fecha_inicio_cobertura || "" },
              { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = res.data || {};
            return {
              id: b.id_beneficiario,
              citasConTarjetaGMF: data.citasConTarjetaGMF ?? 0,
              beneficiosDescuentosGMF: data.beneficiosDescuentosGMF ?? 0,
            };
          } catch (err) {
            console.error(err);
            return { id: b.id_beneficiario, error: true };
          }
        })
      );

      setConsumosGMF((prev) => {
        const next = { ...prev };
        resultados.forEach((r) => {
          next[r.id] = r.error
            ? { error: true }
            : { citasConTarjetaGMF: r.citasConTarjetaGMF, beneficiosDescuentosGMF: r.beneficiosDescuentosGMF };
        });
        return next;
      });
    } catch (err) {
      console.error(err);
      setConsumosGMF((prev) => {
        const next = { ...prev };
        conPaciente.forEach((b) => { next[b.id_beneficiario] = { error: true }; });
        return next;
      });
    }
  };

  const beneficiariosActivos = beneficiarios.filter((b) => b.estado === "ACTIVO" && b.parentesco?.toLowerCase() !== "titular");
  const puedeAgregarBeneficiario = beneficiariosActivos.length < 3;

  const cancelarFormBeneficiario = () => {
    setBenefFormMode(null);
    setBenefFormData({});
  };

  const abrirAgregarBeneficiario = () => {
    if (!puedeAgregarBeneficiario) {
      Swal.fire({
        icon: "info",
        title: "Plan familiar completo",
        text: "Este suscriptor ya tiene 3 beneficiarios activos (el máximo permitido). Inactiva uno para poder agregar otro.",
      });
      return;
    }
    setBenefFormData({ tipo_documento: "CC", numero_documento: "", nombres: "", apellidos: "", telefono: "", parentesco: "", email: "", fecha_nacimiento: "" });
    setBenefFormMode("crear");
  };

  const abrirEdicionBeneficiario = (b) => {
    setBenefFormData({
      tipo_documento: b.tipo_documento || "",
      numero_documento: b.numero_documento || "",
      nombres: b.nombres || "",
      apellidos: b.apellidos || "",
      telefono: b.telefono || "",
      parentesco: b.parentesco || "",
      email: b.email || "",
      fecha_nacimiento: b.fecha_nacimiento ? b.fecha_nacimiento.split("T")[0] : "",
    });
    setBenefFormMode(b.id_beneficiario);
  };

  const guardarBeneficiario = async () => {
    setSavingBenef(true);
    try {
      const usuario = cookies.get("nombreUsuario") || "";
      if (benefFormMode === "crear") {
        const idPaciente = await validarOCrearPaciente(benefFormData, suscriptorActivo.id_suscripcion);
        await actualizarSuscripcionGMF(idPaciente, suscriptorActivo.id_suscripcion);

        await axios.post(`${API}/CrearBeneficiario`, {
          suscriptor_id: suscriptorActivo.id_suscriptor,
          ...benefFormData,
          usuario_registra: usuario,
          paciente_id: idPaciente,
        });
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: "Beneficiario agregado correctamente",
          showConfirmButton: false, timer: 3000, timerProgressBar: true,
        });
      } else {
        await axios.put(`${API}/ActualizarBeneficiario`, {
          id_beneficiario: benefFormMode,
          nombres: benefFormData.nombres,
          apellidos: benefFormData.apellidos,
          telefono: benefFormData.telefono,
          parentesco: benefFormData.parentesco,
          email: benefFormData.email,
          fecha_nacimiento: benefFormData.fecha_nacimiento,
          usuario_modifica: usuario,
        });
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: "Beneficiario actualizado correctamente",
          showConfirmButton: false, timer: 3000, timerProgressBar: true,
        });
      }
      cancelarFormBeneficiario();
      verBeneficiarios(suscriptorActivo);
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.response?.data?.glosaResultado || "Error al guardar el beneficiario.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setSavingBenef(false);
    }
  };

  const inactivarBeneficiario = async (b) => {
    const consumo = consumosGMF[b.id_beneficiario];
    const yaUsoBeneficios =
      consumo && !consumo.loading && !consumo.error &&
      ((consumo.citasConTarjetaGMF ?? 0) > 0 || (consumo.beneficiosDescuentosGMF ?? 0) > 0);

    if (yaUsoBeneficios) {
      Swal.fire({
        icon: "warning",
        title: "No se puede inactivar",
        text: "Este beneficiario ya hizo uso de los beneficios de la tarjeta GMF, por lo que no se puede inactivar.",
      });
      return;
    }

    const confirmacion = await Swal.fire({
      title: "¿Inactivar beneficiario?",
      html: `
        <p style="font-size:0.95rem;color:#374151;margin-bottom:8px">
          Se inactivará al beneficiario:
        </p>
        <p style="font-size:0.9rem;font-weight:600;color:#1e293b;margin-bottom:4px">
          ${[b.nombres, b.apellidos].filter(Boolean).join(" ")}
        </p>
        <p style="font-size:0.82rem;color:#6c757d">
          ${b.tipo_documento} ${b.numero_documento}
        </p>
        <p style="font-size:0.82rem;color:#dc3545;margin-top:8px">
          Esto libera un cupo del plan familiar. Podrás volver a activarlo más adelante si hay cupo disponible.
        </p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      customClass: { confirmButton: "swal-btn-danger" },
    });
    if (!confirmacion.isConfirmed) return;

    try {
      if (b.paciente_id) {
        await actualizarSuscripcionGMF(b.paciente_id, null);
      }

      const usuarioMod = cookies.get("nombreUsuario") || "";
      await axios.put(`${API}/InactivarBeneficiario`, { id_beneficiario: b.id_beneficiario, usuario_modifica: usuarioMod });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Beneficiario inactivado correctamente",
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      });
      verBeneficiarios(suscriptorActivo);
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.mensaje || "Error al inactivar el beneficiario.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };

  const activarBeneficiario = async (b) => {
    if (!puedeAgregarBeneficiario) {
      Swal.fire({
        icon: "info",
        title: "Plan familiar completo",
        text: "Este suscriptor ya tiene 3 beneficiarios activos (el máximo permitido). Inactiva otro para poder activar este.",
      });
      return;
    }

    try {
      if (b.paciente_id) {
        await actualizarSuscripcionGMF(b.paciente_id, suscriptorActivo.id_suscripcion);
      }

      const usuarioMod = cookies.get("nombreUsuario") || "";
      await axios.put(`${API}/ActivarBeneficiario`, { id_beneficiario: b.id_beneficiario, usuario_modifica: usuarioMod });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Beneficiario activado correctamente",
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      });
      verBeneficiarios(suscriptorActivo);
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.mensaje || "Error al activar el beneficiario.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };

  // ── Acudiente (planes individuales) ────────────────────────────────────────
  const verAcudiente = async (suscriptor) => {
    setAcudientes([]);
    setLoadingAcudiente(true);
    try {
      const res = await axios.get(`${API}/ObtenerAcudiente`, {
        params: { suscriptor_id: suscriptor.id_suscriptor }
      });
      setAcudientes(res.data?.data || res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingAcudiente(false);
    }
  };

  // ── Diálogo de link de pago generado (copiar / WhatsApp / correo) ───────────
  const mostrarDialogoLinkPago = async (suscriptor, url_pago, tipo_pago) => {
    const enviarWhatsApp = async () => {
      try {
        const asesorWeb = cookies.get("nombreUsuario") || "";
        await axios.post(`${baseURL}/api/Chat/EnviarMensajeWhatsApp`, {
          asesorWeb: asesorWeb,
          telefono: suscriptor.celular,
          mensaje: `Hola ${suscriptor.nombresApellidos}. Tu proceso de afiliación está casi listo. Para finalizar, realiza tu pago en el siguiente enlace: ${url_pago}`
        });
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: `WhatsApp enviado a ${suscriptor.celular}`,
          showConfirmButton: false, timer: 3500, timerProgressBar: true,
        });
      } catch (err) {
        const msg = err.response?.data?.mensaje || "Error al enviar el mensaje de WhatsApp.";
        Swal.fire({ icon: "error", title: "Error", text: msg });
      }
    };
    const enviarCorreo = async () => {
      try {
        await axios.post(`${API}/EnviarCorreoLinkPago`, {
          id: suscriptor.id_suscriptor,
          correo: suscriptor.email,
          nombres: suscriptor.nombresApellidos,
          nroDocumento: suscriptor.documento,
          linkPago: url_pago,
          nombrePlan: suscriptor.nombre_plan,
        });
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: `Correo enviado a ${suscriptor.email}`,
          showConfirmButton: false, timer: 3500, timerProgressBar: true,
        });
      } catch (err) {
        const msg = err.response?.data?.mensaje || "Error al enviar el correo.";
        Swal.fire({ icon: "error", title: "Error", text: msg });
      }
    };

    await Swal.fire({
      title: tipo_pago === "PSE" ? "🏦 Link PSE" : "🔗 Link de pago",
      html: `
        <p style="font-size:0.88rem;color:#6c757d;margin-bottom:12px">
          ${tipo_pago === "PSE"
          ? "Pago PSE en curso. Link de redirección:"
          : "Link generado. Compártelo con el suscriptor:"}
        </p>

        <!-- URL + copiar -->
        <div style="display:flex;align-items:center;gap:8px;background:#f8f9fa;border:1px solid #dee2e6;border-radius:8px;padding:10px 14px;margin-bottom:16px">
          <span style="font-size:0.75rem;color:#495057;word-break:break-all;flex:1;text-align:left">${url_pago}</span>
          <button id="btnCopiar" style="flex-shrink:0;background:#1a56db;color:#fff;border:none;border-radius:6px;padding:5px 12px;font-size:0.78rem;cursor:pointer;white-space:nowrap">
            Copiar
          </button>
        </div>

        <!-- Acciones de envío -->
        <p style="font-size:0.78rem;color:#adb5bd;margin-bottom:10px;text-transform:uppercase;letter-spacing:0.5px;font-weight:600">Enviar por</p>
        <div style="display:flex;gap:10px;justify-content:center">
          <button id="btnWhatsApp" style="display:inline-flex;align-items:center;gap:8px;background:#25D366;color:#fff;border:none;border-radius:8px;padding:9px 20px;font-size:0.85rem;font-weight:600;cursor:pointer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp
          </button>
          <button id="btnCorreo" style="display:inline-flex;align-items:center;gap:8px;background:#e8f0fe;color:#1a56db;border:1px solid #bfdbfe;border-radius:8px;padding:9px 20px;font-size:0.85rem;font-weight:600;cursor:pointer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1a56db" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>
            Correo
          </button>
        </div>`,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: "Cerrar",
      cancelButtonColor: "#6c757d",
      didOpen: () => {
        document.getElementById("btnCopiar")?.addEventListener("click", () => {
          navigator.clipboard.writeText(url_pago).then(() => {
            const btn = document.getElementById("btnCopiar");
            if (btn) { btn.textContent = "✓ Copiado"; btn.style.background = "#28a745"; }
          });
        });
        document.getElementById("btnWhatsApp")?.addEventListener("click", () => {
          enviarWhatsApp();
        });
        document.getElementById("btnCorreo")?.addEventListener("click", () => {
          enviarCorreo();
        });
      },
    });
  };

  // ── Enviar link de pago ──────────────────────────────────────────────────────
  const enviarLinkPago = async (suscriptor) => {
    const confirmacion = await Swal.fire({
      title: "¿Obtener link de pago?",
      html: `<b>${suscriptor.nombresApellidos}</b><br/>
             <span style="color:#6c757d;font-size:0.9em">${suscriptor.celular} / ${suscriptor.email}</span>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, obtener",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1a56db",
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const esAnual = suscriptor.frecuencia_pago?.toUpperCase() === "ANUAL";
      let tipo_pago;
      let url_pago;

      if (esAnual) {
        const planRes = await axios.get(`${API}/ObtenerValorPlan`, {
          params: { planId: suscriptor.plan_id },
        });
        const precioAnual = Number(
          planRes.data?.precioAnual ?? planRes.data?.data?.precioAnual
        );

        if (!precioAnual || precioAnual <= 0) {
          throw new Error("No se encontró un precio anual válido para el plan.");
        }

        const palabras = (suscriptor.nombresApellidos || "").trim().split(/\s+/);
        const mitad = Math.ceil(palabras.length / 2);
        const name = palabras.slice(0, mitad).join(" ");
        const last_name = palabras.slice(mitad).join(" ");

        const res = await axios.post(`${baseURL}/api/Suscripcion/CobroPorLink`, {
          suscripcion_id: suscriptor.id_suscripcion,
          amount: precioAnual,
          mesesMora: 0,
          mesesPagar: 12,
          currency: "COP",
          description: `Pago anual plan ${suscriptor.nombre_plan} - ${suscriptor.nombresApellidos}`,
          redirect_url: "https://medicentrofamiliarips.com/taarjeta-de-salud-medicentro/",
          order_id: `ORD-${suscriptor.id_suscriptor}-${Date.now()}`,
          expiration_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
          customer: {
            name,
            last_name,
            phone_number: suscriptor.celular || "",
            email: suscriptor.email || "",
          },
        });

        url_pago = res.data?.datos?.checkout_link || res.data?.checkout_link || "";
        tipo_pago = "LINK";
      } else {
        const res = await axios.post(`${API}/EnviarLinkPago`, {
          id_suscriptor: suscriptor.id_suscriptor,
          id_suscripcion: suscriptor.id_suscripcion,
        });

        tipo_pago = res.data?.tipo_pago;
        url_pago = res.data?.url_pago;
      }

      if (!url_pago) {
        throw new Error("El servicio no devolvió un link de pago.");
      }

      await mostrarDialogoLinkPago(suscriptor, url_pago, tipo_pago);

    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.mensaje || err.message || "Intenta nuevamente.";
      Swal.fire({ icon: "error", title: "Error al obtener link de pago", text: msg });
    }
  };

  // ── Ver documentos ───────────────────────────────────────────────────────────
  const verDocumentos = async (suscriptor) => {
    setSuscDocActivo(suscriptor);
    setDocumentos([]);
    setModalDocs(true);
    setTabActivo("documentos");
    setLoadingDocs(true);
    try {
      const res = await axios.get(`${API}/ObtenerDocumentos`, {
        params: { suscriptor_id: suscriptor.id_suscriptor }
      });
      setDocumentos(res.data?.data || res.data || []);
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error al cargar documentos", text: "Intenta nuevamente." });
    } finally {
      setLoadingDocs(false);
    }
  };


  // ── Generar pago efectivo anual ──────────────────────────────────────────────
  const generarPagoEfectivoAnual = async (suscriptor) => {
    // Primero obtener el valor del plan anual
    let valorPlan = null;
    try {
      const res = await axios.get(`${API}/ObtenerValorPlan`, {
        params: { planId: suscriptor.plan_id }
      });
      valorPlan = res.data?.precioAnual ?? res.data?.data?.precioAnual;
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el valor del plan." });
      return;
    }

    const valorFormateado = new Intl.NumberFormat("es-CO", {
      style: "currency", currency: "COP", minimumFractionDigits: 0
    }).format(valorPlan);

    const confirmacion = await Swal.fire({
  title: "💰 Pago anual efectivo",
  html: `
    <p style="font-size:0.95rem;color:#374151;margin-bottom:8px">
      ${suscriptor.frecuencia_pago?.toUpperCase() === "MENSUAL"
        ? "La frecuencia pasará de <b>MENSUAL</b> a <b>ANUAL</b>."
        : "Se generará un <b>pago anual en efectivo</b> para este suscriptor."
      }
    </p>
    <p style="font-size:0.9rem;color:#6c757d;margin-bottom:12px">
      Plan: <b>${suscriptor.nombre_plan}</b>
    </p>
    <div style="background:#f0fdf4;border:1px solid #86efac;border-radius:10px;padding:12px 20px;display:inline-block">
      <span style="font-size:0.82rem;color:#166534;font-weight:600;text-transform:uppercase;letter-spacing:0.5px">Costo anual</span>
      <div style="font-size:1.6rem;font-weight:700;color:#15803d">${valorFormateado}</div>
    </div>
    <p style="font-size:0.82rem;color:#9ca3af;margin-top:12px">
      ¿Desea continuar con el pago anual?
    </p>`,
  icon: "question",
  showCancelButton: true,
  confirmButtonText: "Sí, continuar",
  cancelButtonText: "Cancelar",
  confirmButtonColor: "#15803d",
});

    if (!confirmacion.isConfirmed) return;

    try {
      const usuarioRegistra = cookies.get("idUsuario") || 1;
      await axios.post(`${API}/GenerarPagoEfectivoAnual`, null, {
        params: {
          suscripcionId: suscriptor.id_suscripcion,
          usuarioRegistra: usuarioRegistra,
        }
      });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Pago anual generado exitosamente",
        showConfirmButton: false, timer: 3500, timerProgressBar: true,
      });
      fetchSuscriptores(); // Refresca la grilla
    } catch (err) {
      const msg = err.response?.data?.mensaje || "Error al generar el pago anual.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };

  // ── Mostrar modal de pago por nómina ─────────────────────────────────────────
  const mostrarPagoNomina = async (suscriptor) => {
    let valorPlan = null;
    try {
      const res = await axios.get(`${API}/ObtenerValorPlan`, {
        params: { planId: suscriptor.plan_id }
      });
      valorPlan = res.data?.precioAnual ?? res.data?.data?.precioAnual;
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el valor del plan." });
      return;
    }

    const valorFormateado = new Intl.NumberFormat("es-CO", {
      style: "currency", currency: "COP", minimumFractionDigits: 0
    }).format(valorPlan);

    const confirmacion = await Swal.fire({
      title: "💰 Pago Nómina",
      html: `
        <p style="font-size:0.95rem;color:#374151;margin-bottom:8px">
          ${suscriptor.frecuencia_pago?.toUpperCase() === "MENSUAL"
            ? "La frecuencia pasará de <b>MENSUAL</b> a <b>ANUAL</b>."
            : "Se generará un <b>pago anual en efectivo</b> para este suscriptor."
          }
        </p>
        <p style="font-size:0.9rem;color:#6c757d;margin-bottom:12px">
          Plan: <b>${suscriptor.nombre_plan}</b>
        </p>
        <div style="background:#f0fdf4;border:1px solid #86efac;border-radius:10px;padding:12px 20px;display:inline-block">
          <span style="font-size:0.82rem;color:#166534;font-weight:600;text-transform:uppercase;letter-spacing:0.5px">Costo anual</span>
          <div style="font-size:1.6rem;font-weight:700;color:#15803d">${valorFormateado}</div>
        </div>
        <p style="font-size:0.82rem;color:#9ca3af;margin-top:12px">
          ¿Desea continuar con el pago anual?
        </p>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, continuar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#15803d",
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const usuarioRegistra = cookies.get("idUsuario") || 1;
      await axios.post(`${API}/GenerarPagoNomina`, null, {
        params: {
          suscripcionId: suscriptor.id_suscripcion,
          usuarioRegistra,
        }
      });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Pago por nómina generado exitosamente",
        showConfirmButton: false, timer: 3500, timerProgressBar: true,
      });
      fetchSuscriptores();
    } catch (err) {
      const msg = err.response?.data?.mensaje || "Error al generar el pago por nómina.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };


  // ── Abrir modal de pago de N meses ───────────────────────────────────────────
  const abrirModalPagoMeses = async (suscriptor) => {
    setSuscPagoMesesActivo(suscriptor);
    setMesesAPagar(1);
    setMedioPagoMeses(esPorNomina(suscriptor) ? "EFECTIVO" : "LINK");
    setValorPlanMensual(0);
    setValorPlanAnual(0);
    setMesesYaPagados(0);
    setModalPagoMeses(true);
    setLoadingPagoMeses(true);
    try {
      const [resPlan, resMeses] = await Promise.all([
        axios.get(`${API}/ObtenerValorPlan`, { params: { planId: suscriptor.plan_id } }),
        axios.get(`${API}/ObtenerMesesPagados`, { params: { suscripcionId: suscriptor.id_suscripcion } }),
      ]);
      const precioMensual = Number(resPlan.data?.precio ?? resPlan.data?.data?.precio ?? 0);
      const precioAnual = Number(resPlan.data?.precioAnual ?? resPlan.data?.data?.precioAnual ?? 0);
      setValorPlanMensual(precioMensual);
      setValorPlanAnual(precioAnual);
      setMesesYaPagados(Number(resMeses.data?.data?.mesesPagados ?? 0));
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el valor del plan o los meses ya pagados." });
      setModalPagoMeses(false);
    } finally {
      setLoadingPagoMeses(false);
    }
  };

  // ── Desglose de pago: prorrateo (hoy → día 1 del mes siguiente) + N meses ────
  // El prorrateo alinea la nueva fecha de vencimiento al día 1 del mes, dentro
  // de la ventana de "primeros 5 días" que usa el negocio para el ciclo de cobro.
  const calcularDesglosePagoMeses = () => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // 12 meses = pago anual pleno, sin prorrateo: se cobra el valor anual tal cual.
    if (mesesAPagar === 12) {
      const nuevaFechaFinCobertura = new Date(hoy.getFullYear() + 1, hoy.getMonth(), hoy.getDate());
      return { diasProrrateo: 0, montoProrrateo: 0, montoMeses: valorPlanAnual, montoTotal: valorPlanAnual, nuevaFechaFinCobertura };
    }

    const dia1MesSiguiente = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 1);
    const nuevaFechaFinCobertura = new Date(dia1MesSiguiente.getFullYear(), dia1MesSiguiente.getMonth() + mesesAPagar, 1);

    // El prorrateo solo aplica en el primer pago de la suscripción; si ya hay
    // meses pagados en el año vigente, se cobran los meses completos sin prorratear.
    if (mesesYaPagados > 0) {
      const montoMeses = valorPlanMensual * mesesAPagar;
      return { diasProrrateo: 0, montoProrrateo: 0, montoMeses, montoTotal: montoMeses, nuevaFechaFinCobertura };
    }

    const diasProrrateo = Math.round((dia1MesSiguiente - hoy) / (1000 * 60 * 60 * 24));

    const tarifaDiaria = valorPlanMensual / 30;
    const montoProrrateo = Math.round(tarifaDiaria * diasProrrateo);
    const montoMeses = valorPlanMensual * mesesAPagar;
    const montoTotal = montoProrrateo + montoMeses;

    return { diasProrrateo, montoProrrateo, montoMeses, montoTotal, nuevaFechaFinCobertura };
  };

  // ── Confirmar pago de N meses ────────────────────────────────────────────────
  const confirmarPagoMeses = async () => {
    if (!suscPagoMesesActivo) return;
    const topeMeses = Math.max(0, 12 - mesesYaPagados);
    if (topeMeses === 0) {
      Swal.fire({ icon: "info", title: "Año de cobertura completo", text: "Ya se pagaron los 12 meses del año de cobertura vigente." });
      return;
    }
    if (!mesesAPagar || mesesAPagar < 1 || mesesAPagar > topeMeses) {
      Swal.fire({ icon: "warning", title: "Meses inválidos", text: `Selecciona entre 1 y ${topeMeses} meses.` });
      return;
    }

    const suscriptor = suscPagoMesesActivo;
    const { montoTotal } = calcularDesglosePagoMeses();
    setProcesandoPagoMeses(true);
    try {
      // Adelanto de pagos (ACTIVA): cancelar el débito automático en OpenPay para
      // que no se vuelvan a cobrar los meses que ya se están pagando por adelantado.
      if (esActiva(suscriptor.estado_suscripcion) && suscriptor.openpay_subscription_id && suscriptor.openpay_customer_id) {
        try {
          await axios.delete(
            `${baseURL}/api/Suscripcion/CancelarSuscripcion/${suscriptor.openpay_customer_id}/${suscriptor.openpay_subscription_id}`
          );
        } catch (cancelErr) {
          console.error("Error al cancelar suscripción OpenPay:", cancelErr);
          if (process.env.REACT_APP_BLOQUEAR_PAGO_SI_FALLA_CANCELACION_OPENPAY === "true") {
            throw new Error("No se pudo cancelar el débito automático en OpenPay. El pago no fue registrado para evitar doble cobro.");
          }
        }
      }

      if (medioPagoMeses === "EFECTIVO") {
        const usuarioRegistra = cookies.get("idUsuario") || 1;
        const endpointPago = esActiva(suscriptor.estado_suscripcion) ? "GenerarPagoMesesAdelanto" : "GenerarPagoMeses";
        const res = await axios.post(`${API}/${endpointPago}`, null, {
          params: {
            suscripcionId: suscriptor.id_suscripcion,
            meses: mesesAPagar,
            montoTotal: Math.round(montoTotal),
            usuarioRegistra,
          }
        });
        const resultado = res.data?.data;
        if (!resultado || resultado.codEstado === false) {
          throw new Error(resultado?.glsGlosa || "El pago no pudo registrarse.");
        }
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: `Pago de ${mesesAPagar} mes(es) registrado exitosamente`,
          showConfirmButton: false, timer: 3500, timerProgressBar: true,
        });
        setModalPagoMeses(false);
        fetchSuscriptores();
      } else {
        const monto = montoTotal;
        const palabras = (suscriptor.nombresApellidos || "").trim().split(/\s+/);
        const mitad = Math.ceil(palabras.length / 2);
        const name = palabras.slice(0, mitad).join(" ");
        const last_name = palabras.slice(mitad).join(" ");

        const res = await axios.post(`${baseURL}/api/Suscripcion/CobroPorLink`, {
          suscripcion_id: suscriptor.id_suscripcion,
          amount: monto,
          mesesMora: 0,
          mesesPagar: mesesAPagar,
          currency: "COP",
          description: `Pago ${mesesAPagar} ${mesesAPagar === 1 ? "mes" : "meses"} plan ${suscriptor.nombre_plan}`,
          redirect_url: "https://medicentrofamiliarips.com/taarjeta-de-salud-medicentro/",
          order_id: `ORD-${suscriptor.id_suscriptor}-${Date.now()}`,
          expiration_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
          customer: {
            name,
            last_name,
            phone_number: suscriptor.celular || "",
            email: suscriptor.email || "",
          },
        });

        const url_pago = res.data?.datos?.checkout_link || res.data?.checkout_link || "";
        if (!url_pago) {
          throw new Error("El servicio no devolvió un link de pago.");
        }

        setModalPagoMeses(false);
        await mostrarDialogoLinkPago(suscriptor, url_pago, "LINK");
      }
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message || "Error al registrar el pago.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setProcesandoPagoMeses(false);
    }
  };

  // ── Finalizar suscripción (con opción de renovar duplicando el plan) ──────────
  const permitirFinalizarSinAgotarBeneficios = process.env.REACT_APP_PERMITIR_FINALIZAR_SIN_AGOTAR_BENEFICIOS === "true";

  const abrirModalFinalizar = async (suscriptor, { soloRenovar: soloRenovarParam = false } = {}) => {
    // Solo se exige haber agotado los beneficios GMF al finalizar una suscripción ACTIVA
    // (no aplica al "Renovar suscripción" de una fila que ya está FINALIZADA).
    if (!soloRenovarParam && !permitirFinalizarSinAgotarBeneficios) {
      Swal.fire({ title: "Validando beneficios GMF...", didOpen: () => Swal.showLoading(), allowOutsideClick: false });
      try {
        const conteo = await consultarConteoCitasGmf(suscriptor);
        const agotoHemograma = conteo.maxHemograma <= 0 || conteo.consumidoH >= conteo.maxHemograma;
        const agotoGeneral = conteo.maxGeneral <= 0 || conteo.consumidoG >= conteo.maxGeneral;
        const agotoEspecialidades = conteo.maxEspecialidades <= 0 || conteo.consumidoE >= conteo.maxEspecialidades;
        Swal.close();
        if (!(agotoHemograma && agotoGeneral && agotoEspecialidades)) {
          Swal.fire({
            icon: "warning",
            title: "Aún no ha agotado los beneficios de su tarjeta",
          });
          return;
        }
      } catch (err) {
        Swal.close();
        Swal.fire({ icon: "error", title: "No se pudo validar el consumo de beneficios GMF", text: "Intenta nuevamente." });
        return;
      }
    }

    setSuscFinalizarActivo(suscriptor);
    setSoloRenovar(soloRenovarParam);
    setDeseaRenovar(soloRenovarParam ? true : null);
    setFrecuenciaRenovacion(suscriptor.frecuencia_pago?.toUpperCase() === "ANUAL" ? "ANUAL" : "MENSUAL");
    setMesesRenovAPagar(1);
    setMedioPagoRenov("EFECTIVO");
    setValorPlanRenovMensual(0);
    setValorPlanRenovAnual(0);
    setModalFinalizar(true);
    setLoadingFinalizar(true);
    try {
      const resPlan = await axios.get(`${API}/ObtenerValorPlan`, { params: { planId: suscriptor.plan_id } });
      const precioMensual = Number(resPlan.data?.precio ?? resPlan.data?.data?.precio ?? 0);
      const precioAnual = Number(resPlan.data?.precioAnual ?? resPlan.data?.data?.precioAnual ?? 0);
      setValorPlanRenovMensual(precioMensual);
      setValorPlanRenovAnual(precioAnual);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo obtener el valor del plan." });
    } finally {
      setLoadingFinalizar(false);
    }
  };

  // ── Desglose del cobro inicial de la renovación ──────────────────────────────
  // ANUAL: siempre se cobra el valor pleno del año (sin prorrateo), igual que "Pago anual efectivo".
  // MENSUAL: prorrateo (hoy → día 1 del mes siguiente) + los meses elegidos, igual que "Pagar N meses"
  // con una suscripción nueva (mesesYaPagados = 0). Si elige los 12 meses, se cobra el valor anual pleno.
  const calcularDesglosePagoRenovacion = () => {
    if (frecuenciaRenovacion === "ANUAL" || mesesRenovAPagar === 12) {
      return { diasProrrateo: 0, montoProrrateo: 0, montoMeses: valorPlanRenovAnual, montoTotal: valorPlanRenovAnual };
    }
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const dia1MesSiguiente = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 1);
    const diasProrrateo = Math.round((dia1MesSiguiente - hoy) / (1000 * 60 * 60 * 24));
    const tarifaDiaria = valorPlanRenovMensual / 30;
    const montoProrrateo = Math.round(tarifaDiaria * diasProrrateo);
    const montoMeses = valorPlanRenovMensual * mesesRenovAPagar;
    return { diasProrrateo, montoProrrateo, montoMeses, montoTotal: montoProrrateo + montoMeses };
  };

  const confirmarFinalizar = async () => {
    if (!suscFinalizarActivo || deseaRenovar === null) return;
    setProcesandoFinalizar(true);
    try {
      const usuarioMod = cookies.get("nombreUsuario") || "";
      const res = await axios.post(`${API}/FinalizarSuscripcion`, {
        id_suscripcion: suscFinalizarActivo.id_suscripcion,
        renovar: deseaRenovar,
        plan_id: suscFinalizarActivo.plan_id,
        frecuencia_pago: deseaRenovar ? frecuenciaRenovacion : null,
        codigo_asesor: suscFinalizarActivo.codigo_asesor,
        usuario_mod: usuarioMod,
      });
      const resultado = res.data;
      if (!resultado || resultado.ok !== 1) {
        throw new Error(resultado?.mensaje || "No se pudo finalizar la suscripción.");
      }

      // La suscripción ya quedó finalizada (y, si aplica, renovada en SIN PAGO).
      // Si el usuario decidió renovar, intentamos registrar el cobro inicial de una vez.
      if (deseaRenovar && resultado.nuevaSuscripcionId) {
        try {
          await registrarCobroRenovacion(resultado.nuevaSuscripcionId);
        } catch (errCobro) {
          const msgCobro = errCobro.response?.data?.mensaje || errCobro.message || "Error al registrar el cobro.";
          Swal.fire({
            icon: "warning",
            title: "Suscripción renovada, pero el cobro no se pudo registrar",
            text: `${msgCobro} Puedes intentarlo de nuevo desde las acciones de la tabla (Link de pago / Pagar meses).`,
          });
          setModalFinalizar(false);
          fetchSuscriptores();
          return;
        }

        try {
          await sincronizarCitasGMFRenovacion(suscFinalizarActivo.id_suscriptor, resultado.nuevaSuscripcionId);
        } catch (errCitas) {
          Swal.fire({
            icon: "warning",
            title: "Suscripción renovada, pero no se sincronizó con el sistema de citas",
            text: `${errCitas.message} Puedes reintentarlo editando o reactivando cada beneficiario desde la pestaña Beneficiarios.`,
          });
          setModalFinalizar(false);
          fetchSuscriptores();
          return;
        }
      }

      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: soloRenovar ? "Suscripción renovada correctamente" : (deseaRenovar ? "Suscripción finalizada y renovada correctamente" : "Suscripción finalizada correctamente"),
        showConfirmButton: false, timer: 3500, timerProgressBar: true,
      });
      setModalFinalizar(false);
      fetchSuscriptores();
    } catch (err) {
      const msg = err.response?.data?.mensaje || err.message || "Error al finalizar la suscripción.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setProcesandoFinalizar(false);
    }
  };

  // ── Registrar el cobro inicial de la suscripción recién renovada ────────────
  const registrarCobroRenovacion = async (nuevaSuscripcionId) => {
    const suscriptor = suscFinalizarActivo;
    const { montoTotal } = calcularDesglosePagoRenovacion();
    const esAnual = frecuenciaRenovacion === "ANUAL" || mesesRenovAPagar === 12;
    const usuarioRegistra = cookies.get("idUsuario") || 1;

    if (medioPagoRenov === "EFECTIVO") {
      if (esAnual) {
        const res = await axios.post(`${API}/GenerarPagoEfectivoAnual`, null, {
          params: { suscripcionId: nuevaSuscripcionId, usuarioRegistra },
        });
        const resultado = res.data?.data;
        if (!resultado || resultado.codEstado === false) {
          throw new Error(resultado?.glsGlosa || "El pago anual no pudo registrarse.");
        }
      } else {
        const res = await axios.post(`${API}/GenerarPagoMeses`, null, {
          params: { suscripcionId: nuevaSuscripcionId, meses: mesesRenovAPagar, montoTotal: Math.round(montoTotal), usuarioRegistra },
        });
        const resultado = res.data?.data;
        if (!resultado || resultado.codEstado === false) {
          throw new Error(resultado?.glsGlosa || "El pago no pudo registrarse.");
        }
      }
      return;
    }

    // Medio de pago: LINK de pasarela
    const palabras = (suscriptor.nombresApellidos || "").trim().split(/\s+/);
    const mitad = Math.ceil(palabras.length / 2);
    const name = palabras.slice(0, mitad).join(" ");
    const last_name = palabras.slice(mitad).join(" ");

    const res = await axios.post(`${baseURL}/api/Suscripcion/CobroPorLink`, {
      suscripcion_id: nuevaSuscripcionId,
      amount: montoTotal,
      mesesMora: 0,
      mesesPagar: esAnual ? 12 : mesesRenovAPagar,
      currency: "COP",
      description: `Renovación ${esAnual ? "anual" : `${mesesRenovAPagar} ${mesesRenovAPagar === 1 ? "mes" : "meses"}`} plan ${suscriptor.nombre_plan}`,
      redirect_url: "https://medicentrofamiliarips.com/taarjeta-de-salud-medicentro/",
      order_id: `ORD-${suscriptor.id_suscriptor}-${Date.now()}`,
      expiration_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      customer: {
        name,
        last_name,
        phone_number: suscriptor.celular || "",
        email: suscriptor.email || "",
      },
    });

    const url_pago = res.data?.datos?.checkout_link || res.data?.checkout_link || "";
    if (!url_pago) {
      throw new Error("El servicio no devolvió un link de pago.");
    }
    await mostrarDialogoLinkPago(suscriptor, url_pago, "LINK");
  };

  // ── Re-vincular al sistema externo de citas GMF tras una renovación ─────────
  // El sistema de citas guarda, por paciente, a qué suscripcionId está atado. Al renovar
  // (suscriptor y beneficiarios se reutilizan, pero la suscripción es una fila nueva),
  // hay que re-apuntar a cada paciente activo hacia la nueva suscripción.
  const sincronizarCitasGMFRenovacion = async (suscriptorId, nuevaSuscripcionId) => {
    const res = await axios.get(`${API}/ObtenerBeneficiarios`, { params: { suscriptor_id: suscriptorId } });
    const lista = res.data?.data || res.data || [];
    const conPaciente = lista.filter((b) => b.paciente_id && b.estado?.toUpperCase() !== "INACTIVO");
    if (conPaciente.length === 0) return;

    const resultados = await Promise.allSettled(
      conPaciente.map((b) => actualizarSuscripcionGMF(b.paciente_id, nuevaSuscripcionId))
    );
    const fallidos = resultados.filter((r) => r.status === "rejected");
    if (fallidos.length > 0) {
      console.error("Error al sincronizar citas GMF tras renovación:", fallidos.map((f) => f.reason));
      throw new Error(`No se pudo sincronizar ${fallidos.length} de ${conPaciente.length} pacientes con el sistema de citas.`);
    }
  };

  // ── Citas consumidas (resumen + detalle unificados en un solo modal) ───────
  const CITAS_API_BASE = process.env.REACT_APP_CITAS_API_BASE_URL;
  const citasAxios = axios.create();

  const obtenerTokenCitas = async () => {
    const authRes = await citasAxios.post(`${CITAS_API_BASE}/auth/login`, {
      usuario: process.env.REACT_APP_CITAS_AUTH_USER,
      password: process.env.REACT_APP_CITAS_AUTH_PASS,
    });
    const token = authRes.data?.token;
    if (!token) throw new Error("No se obtuvo token de autenticación.");
    return token;
  };

  const consultarConteoCitasGmf = async (suscriptor) => {
    const token = await obtenerTokenCitas();
    const res = await citasAxios.post(
      `${CITAS_API_BASE}/citas/conteocitas`,
      {
        SuscripcionId: suscriptor.id_suscripcion,
        FechaInicio: suscriptor.fecha_inicio_cobertura || "",
        FechaFin: suscriptor.fecha_fin_cobertura || "",
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const { totalHemograma, totalMedicinaGeneral, totalEspecialidades } = res.data;
    return {
      consumidoH: totalHemograma ?? 0,
      maxHemograma: suscriptor.cantidad_citas_hemograma ?? 0,
      consumidoG: totalMedicinaGeneral ?? 0,
      maxGeneral: suscriptor.cantidad_citas_general ?? 0,
      consumidoE: totalEspecialidades ?? 0,
      maxEspecialidades: suscriptor.cantidad_citas_especialista ?? 0,
    };
  };

  // El dato del paciente sale SOLO de ObtenerBeneficiarios; DetalleCitasGmf solo aporta datos de la cita.
  // Las citas cuyo idPaciente no cruce con ningún paciente_id de beneficiarios se descartan.
  const consultarDetalleCitasGmf = async (suscriptor) => {
    const resBenef = await axios.get(`${API}/ObtenerBeneficiarios`, { params: { suscriptor_id: suscriptor.id_suscriptor } });
    const listaBenef = resBenef.data?.data || resBenef.data || [];

    let citas = [];
    try {
      const token = await obtenerTokenCitas();
      const res = await citasAxios.post(
        `${CITAS_API_BASE}/citas/DetalleCitasGmf`,
        {
          suscripcionId: suscriptor.id_suscripcion,
          fechaInicioSuscripcion: suscriptor.fecha_inicio_cobertura || "",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      citas = Array.isArray(res.data) ? res.data : (res.data?.data || []);
    } catch (err) {
      if (err.response?.status !== 404) throw err;
      citas = []; // Sin citas GMF registradas para esta suscripción: no es un error.
    }

    return citas
      .map((c) => {
        const benef = listaBenef.find((b) => b.paciente_id && String(b.paciente_id) === String(c.idPaciente));
        if (!benef) return null;
        return {
          idPaciente: c.idPaciente,
          nombres: [benef.nombres, benef.apellidos].filter(Boolean).join(" "),
          tipoIdentificacion: benef.tipo_documento,
          numIdentificacion: benef.numero_documento,
          parentesco: benef.parentesco,
          horaCita: c.horaCita,
          especialidad: c.especialidad,
          estado: c.estado,
          tipoMembresia: c.tipoMembresia,
        };
      })
      .filter(Boolean);
  };

  const abrirCitasConsumidas = async (suscriptor) => {
    setSuscCitasGmfActivo(suscriptor);
    setConteoCitasGmf(null);
    setCitasGmfDetalle(null);
    setModalCitasGmf(true);
    setLoadingCitasGmf(true);

    const [conteoRes, detalleRes] = await Promise.allSettled([
      consultarConteoCitasGmf(suscriptor),
      consultarDetalleCitasGmf(suscriptor),
    ]);

    if (conteoRes.status === "fulfilled") {
      setConteoCitasGmf(conteoRes.value);
    } else {
      console.error(conteoRes.reason);
      setConteoCitasGmf({ error: true });
    }

    if (detalleRes.status === "fulfilled") {
      setCitasGmfDetalle(detalleRes.value);
    } else {
      console.error(detalleRes.reason);
      setCitasGmfDetalle({ error: true });
    }

    setLoadingCitasGmf(false);
  };

  const renderTablaCitasGmf = (titulo, filas) => (
    <div className="citas-gmf-tabla-bloque">
      <h5 className="detalle-section-title">{titulo} ({filas.length})</h5>
      {filas.length === 0 ? (
        <div className="sin-resultados">Sin citas registradas.</div>
      ) : (
        <table className="usuarios-table benef-table">
          <thead>
            <tr><th>#</th><th>Paciente</th><th>Documento</th><th>Beneficiario</th><th>Fecha Cita</th><th>Especialidad</th><th>Estado</th></tr>
          </thead>
          <tbody>
            {filas.map((c, idx) => (
              <tr key={`${c.idPaciente}-${idx}`}>
                <td className="td-id">{idx + 1}</td>
                <td><span className="suscriptor-nombre">{c.nombres}</span></td>
                <td><span className="suscriptor-documento">{c.tipoIdentificacion} {c.numIdentificacion}</span></td>
                <td>
                  <span className={`badge-parentesco ${c.parentesco?.toLowerCase() === "titular" ? "badge-titular" : "badge-familiar"}`}>{c.parentesco}</span>
                </td>
                <td className="td-secondary">{c.horaCita}</td>
                <td className="td-secondary">{c.especialidad}</td>
                <td className="td-secondary">
                  <span className={`badge-cita-estado ${c.estado?.toUpperCase() === "ASISTIDA" ? "badge-cita-asistida" : "badge-cita-otro"}`}>{c.estado}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );


  // ── Inactivar suscriptor ──────────────────────────────────────────────────────
  const inactivarSuscriptor = async (suscriptor) => {
    const confirmacion = await Swal.fire({
      title: "¿Inactivar suscriptor?",
      html: `
        <p style="font-size:0.95rem;color:#374151;margin-bottom:8px">
          Se inactivará al suscriptor:
        </p>
        <p style="font-size:0.9rem;font-weight:600;color:#1e293b;margin-bottom:4px">
          ${suscriptor.nombresApellidos}
        </p>
        <p style="font-size:0.82rem;color:#6c757d">
          ${suscriptor.documento}
        </p>
        <p style="font-size:0.82rem;color:#dc3545;margin-top:8px">
          Esta acción no se puede deshacer.
        </p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      customClass: { confirmButton: "swal-btn-danger" },
    });
    if (!confirmacion.isConfirmed) return;

    try {
      const usuarioMod = cookies.get("nombreUsuario") || "";
      await axios.put(`${API}/InactivarSuscriptor`, {
        id_suscriptor: suscriptor.id_suscriptor,
        usuario_mod: usuarioMod,
      });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Suscriptor inactivado correctamente",
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      });
      fetchSuscriptores();
    } catch (err) {
      const msg = err.response?.data?.mensaje || "Error al inactivar el suscriptor.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    }
  };

  // ── Helpers ──────────────────────────────────────────────────────────────────
  const esPlanFamiliar = (plan) => plan?.toLowerCase().includes("famil");
  const esPlanIndividual = (plan) => !esPlanFamiliar(plan);
  const esFechaInvalida = (fecha) => !fecha || fecha.startsWith("1900-01-01");

  const parsearFechaLocal = (fechaStr) => {
    if (!fechaStr) return null;
    const soloFecha = fechaStr.split("T")[0];
    const [y, m, d] = soloFecha.split("-").map(Number);
    return new Date(y, m - 1, d);
  };

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento || esFechaInvalida(fechaNacimiento)) return null;
    const hoy = new Date();
    const nac = parsearFechaLocal(fechaNacimiento);
    let edad = hoy.getFullYear() - nac.getFullYear();
    const mes = hoy.getMonth() - nac.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < nac.getDate())) edad--;
    return edad;
  };
  const esSinPago = (estado) => estado?.toUpperCase() === "SIN PAGO";
  const esActiva = (estado) => estado?.toUpperCase() === "ACTIVA";
  // ¿El titular ya tiene otra suscripción ACTIVA entre los registros cargados?
  const tieneSuscripcionActiva = (idSuscriptor) => datos.some((d) => d.id_suscriptor === idSuscriptor && esActiva(d.estado_suscripcion));

  const esSinPagoMensual = (s) => esSinPago(s.estado_suscripcion);
  const esPorNomina = (s) => s?.nomina?.toUpperCase() === "SI";


  const badgeEstado = (estado) => {
    const e = estado?.toUpperCase();
    if (e === "ACTIVA") return "badge-activo";
    if (e === "INACTIVA") return "badge-inactivo";
    if (e === "SIN PAGO") return "badge-sinpago";
    if (e === "CANCELADO") return "badge-cancelado";
    if (e === "EN MORA") return "badge-mora";
    if (e === "FINALIZADA") return "badge-finalizada";
    return "badge-inactivo";
  };

  const badgeFrecuencia = (freq) => {
    const f = freq?.toUpperCase();
    if (f === "MENSUAL") return "badge-mensual";
    if (f === "ANUAL") return "badge-anual";
    if (f === "SEMESTRAL") return "badge-semestral";
    return "badge-frecuencia";
  };

  const descargarArchivo = async (url) => {
    try {
      const res = await axios.get(url, { responseType: "blob" });
      const contentType = res.headers["content-type"] || "application/octet-stream";
      const disposition = res.headers["content-disposition"] || "";
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      const filename = match ? match[1].replace(/['"]/g, "") : url.split("/").pop()?.split("?")[0] || "documento";
      const blob = new Blob([res.data], { type: contentType });
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo descargar el archivo." });
    }
  };

  const splitNombresApellidos = (fullName) => {
    if (!fullName) return { nombres: "", apellidos: "" };
    const words = fullName.trim().split(/\s+/);
    if (words.length <= 2) return { nombres: words[0] || "", apellidos: words[1] || "" };
    const mid = Math.ceil(words.length / 2);
    return { nombres: words.slice(0, mid).join(" "), apellidos: words.slice(mid).join(" ") };
  };

  const abrirEdicion = () => {
    if (!suscDetalleActivo) return;
    const { nombres, apellidos } = splitNombresApellidos(suscDetalleActivo.nombresApellidos);
    setEditData({
      id_suscriptor: suscDetalleActivo.id_suscriptor,
      nombres,
      apellidos,
      estado_civil: suscDetalleActivo.estado_civil || "",
      celular: suscDetalleActivo.celular || "",
      email: suscDetalleActivo.email || "",
      medio_contacto: suscDetalleActivo.medio_contacto || "",
      fecha_nacimiento: suscDetalleActivo.fecha_nacimiento
        ? suscDetalleActivo.fecha_nacimiento.split("T")[0]
        : "",
    });
    setEditMode(true);
  };

  const cancelarEdicion = () => {
    setEditMode(false);
    setEditData({});
  };

  const guardarEdicion = async () => {
    setSaving(true);
    try {
      const usuarioModificacion = cookies.get("nombreUsuario") || "";
      await axios.put(`${API}/ActualizarSuscriptor`, {
        ...editData,
        usuarioModificacion,
      });
      Swal.fire({
        toast: true, position: "top-end", icon: "success",
        title: "Suscriptor actualizado correctamente",
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      });
      setEditMode(false);
      setModalDetalle(false);
      fetchSuscriptores();
    } catch (err) {
      const msg = err.response?.data?.mensaje || "Error al actualizar el suscriptor.";
      Swal.fire({ icon: "error", title: "Error", text: msg });
    } finally {
      setSaving(false);
    }
  };

  // ── Paginación ───────────────────────────────────────────────────────────────
  const indexInicio = (paginaActual - 1) * elementosPorPagina;
  const indexFin = indexInicio + elementosPorPagina;
  const datosPaginados = datosFiltrados.slice(indexInicio, indexFin);
  const totalPaginas = Math.ceil(datosFiltrados.length / elementosPorPagina);
  const rangoInicio = Math.max(1, Math.min(paginaActual - 2, totalPaginas - 4));
  const rangoFin = Math.min(totalPaginas, rangoInicio + 4);
  const paginasVisibles = Array.from({ length: rangoFin - rangoInicio + 1 }, (_, i) => rangoInicio + i);

  // ── Render ────────────────────────────────────────────────────────────────────
  return (
    <div className="telefonos-container">
      <div className="telefonos-card">

        {/* Header */}
        <div className="card-header-custom d-flex align-items-center justify-content-between">
          <h3 className="card-title-custom">
            <FaUsers style={{ marginRight: 10 }} />
            Suscriptores
          </h3>
          <button className="btn-refresh-susc" onClick={fetchSuscriptores} title="Actualizar">
            <i className="fas fa-sync-alt" style={{ marginRight: 6 }} />
            Actualizar
          </button>
        </div>

        <div className="form-section">

          {/* ── Filtros ── */}
          <div className="suscriptores-filtros-wrap">
            <div className="usuarios-search-wrap">
              <FaSearch className="usuarios-search-icon" />
              <input
                type="text"
                className="custom-input usuarios-search-input"
                placeholder="Buscar por nombre, documento, celular o email..."
                autoComplete="off"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>

            <div className="usuarios-filter-item">
              <label className="usuarios-filter-label">Plan</label>
              <select className="custom-input" style={{ width: 170 }} value={filtroPlan} onChange={(e) => setFiltroPlan(e.target.value)}>
                <option value="">Todos</option>
                {planesUnicos.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>

            <div className="usuarios-filter-item">
              <label className="usuarios-filter-label">Estado</label>
              <select className="custom-input" style={{ width: 140 }} value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                <option value="">Todos</option>
                <option value="ACTIVA">Activa</option>
                <option value="INACTIVA">Inactiva</option>
                <option value="SIN PAGO">Sin Pago</option>
                <option value="CANCELADO">Cancelado</option>
                <option value="EN MORA">En Mora</option>
                <option value="FINALIZADA">Finalizada</option>
              </select>
            </div>

            <div className="usuarios-filter-item">
              <label className="usuarios-filter-label">Tipo Fecha</label>
              <select className="custom-input" style={{ width: 150 }} value={filtroTipoFecha} onChange={(e) => { setFiltroTipoFecha(e.target.value); setFiltroPrimerPagoDesde(""); setFiltroPrimerPagoHasta(""); }}>
                <option value="">Sin filtro</option>
                <option value="primer_pago">Primer Pago</option>
                <option value="cobertura">Cobertura</option>
              </select>
            </div>

            {filtroTipoFecha && (
              <>
                <div className="usuarios-filter-item">
                  <label className="usuarios-filter-label">{filtroTipoFecha === "primer_pago" ? "Pago Desde" : "Cob. Desde"}</label>
                  <input type="date" className="custom-input" style={{ width: 145 }} value={filtroPrimerPagoDesde} onChange={(e) => setFiltroPrimerPagoDesde(e.target.value)} />
                </div>
                <div className="usuarios-filter-item">
                  <label className="usuarios-filter-label">{filtroTipoFecha === "primer_pago" ? "Pago Hasta" : "Cob. Hasta"}</label>
                  <input type="date" className="custom-input" style={{ width: 145 }} value={filtroPrimerPagoHasta} onChange={(e) => setFiltroPrimerPagoHasta(e.target.value)} />
                </div>
              </>
            )}

            <div className="usuarios-contador">
              <span className="usuarios-badge-count">
                {datosFiltrados.length} suscriptor{datosFiltrados.length !== 1 ? "es" : ""}
              </span>
            </div>
          </div>

          {/* ── Tabla con scroll horizontal ── */}
          <div className="suscriptores-table-scroll">
            <table className="usuarios-table suscriptores-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Documento</th>
                  <th>Nombres y Apellidos</th>
                  <th>Celular</th>
                  <th>Código Asesor</th>
                  <th>Plan</th>
                  <th>Suscripción</th>
                  <th>Frecuencia</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9" className="sin-resultados">
                      <i className="fas fa-spinner fa-spin mr-2" /> Cargando suscriptores...
                    </td>
                  </tr>
                ) : datosPaginados.length > 0 ? (
                  datosPaginados.map((s, idx) => (
                    <tr key={s.id_suscripcion ?? s.id_suscriptor}>
                      <td className="td-id">{indexInicio + idx + 1}</td>
                      <td>
                        <span className="suscriptor-documento">
                          <FaIdCard size={12} style={{ marginRight: 5, opacity: 0.6 }} />
                          {s.documento}
                        </span>
                      </td>
                      <td><span className="suscriptor-nombre">{s.nombresApellidos}</span></td>
                      <td className="td-secondary">{s.celular}</td>
                      <td><span className="td-secondary">{s.codigo_asesor || "—"}</span></td>
                      <td>
                        <span className={`badge-plan ${esPlanFamiliar(s.nombre_plan) ? "badge-plan-familiar" : "badge-plan-basico"}`}>
                          {esPlanFamiliar(s.nombre_plan) && <FaUserFriends size={10} style={{ marginRight: 4 }} />}
                          {s.nombre_plan}
                        </span>
                      </td>
                      <td>
                        <span className={`badge-estado ${badgeEstado(s.estado_suscripcion)}`}>
                          <span className="badge-dot" />
                          {s.estado_suscripcion}
                        </span>
                      </td>
                      <td>
                        <span className={`badge-frecuencia-tag ${badgeFrecuencia(s.frecuencia_pago)}`}>
                          {s.frecuencia_pago}
                        </span>
                      </td>
                      <td>
                        <div className="acciones-wrap">
                          {/* Ver detalle — siempre */}
                          <button className="btn-icono btn-icono-detalle" onClick={() => { setSuscDetalleActivo(s); setModalDetalle(true); setDetalleTab("info"); verDocumentos(s); if (esPlanIndividual(s.nombre_plan)) verAcudiente(s); if (esPlanFamiliar(s.nombre_plan)) verBeneficiarios(s); }} title="Ver detalle">
                            <FaEye size={14} />
                            <span className="icono-tooltip">Ver detalle</span>
                          </button>
                          {/* Citas consumidas — solo ACTIVA */}
                          {esActiva(s.estado_suscripcion) && (
                            <button className="btn-icono btn-icono-citas" onClick={() => abrirCitasConsumidas(s)} title="Ver citas consumidas">
                              <FaCalendarCheck size={14} />
                              <span className="icono-tooltip">Citas consumidas</span>
                            </button>
                          )}
                          {/* Finalizar — solo ACTIVA, permite renovar (duplicar como alta nueva) */}
                          {esActiva(s.estado_suscripcion) && (
                            <button className="btn-icono btn-icono-finalizar" onClick={() => abrirModalFinalizar(s)} title="Finalizar suscripción">
                              <FaBan size={14} />
                              <span className="icono-tooltip">Finalizar</span>
                            </button>
                          )}
                          {/* Inactivar — solo SIN PAGO */}
                          {esSinPago(s.estado_suscripcion) && (
                            <button className="btn-icono btn-icono-inactivar" onClick={() => inactivarSuscriptor(s)} title="Inactivar suscriptor">
                              <FaTrash size={14} />
                              <span className="icono-tooltip">Inactivar</span>
                            </button>
                          )}
                          {/* Link de pago — solo SIN PAGO */}
                          {esSinPago(s.estado_suscripcion) && !esPorNomina(s) && (
                            <button className="btn-icono btn-icono-pago" onClick={() => enviarLinkPago(s)} title="Enviar link de pago">
                              <FaLink size={14} />
                              <span className="icono-tooltip">Link de pago</span>
                            </button>
                          )}

                          {/* Pago efectivo anual — solo SIN PAGO y sin nómina */}
                          {esSinPagoMensual(s) && !esPorNomina(s) && (
                            <button
                              className="btn-icono btn-icono-pago-anual"
                              onClick={() => generarPagoEfectivoAnual(s)}
                              title="Generar pago anual efectivo"
                            >
                              💰
                              <span className="icono-tooltip">Pago anual efectivo</span>
                            </button>
                          )}
                          {/* Pago por nómina — solo informativo por ahora */}
                          {esSinPagoMensual(s) && esPorNomina(s) && (
                            <button
                              type="button"
                              className="btn-icono btn-icono-pago-anual"
                              onClick={() => mostrarPagoNomina(s)}
                              title="Pago por nómina"
                            >
                              <FaFileAlt size={14} />
                              <span className="icono-tooltip">Pago por nómina</span>
                            </button>
                          )}

                          {/* Pagar N meses — solo SIN PAGO */}
                          {esSinPago(s.estado_suscripcion) && (
                            <button
                              type="button"
                              className="btn-icono btn-icono-pago-meses"
                              onClick={() => abrirModalPagoMeses(s)}
                              title="Pagar meses"
                            >
                              <FaMoneyBillWave size={14} />
                              <span className="icono-tooltip">Pagar meses</span>
                            </button>
                          )}

                          {/* Adelantar pagos — solo ACTIVA y frecuencia MENSUAL (anual ya pagó todo el año) */}
                          {esActiva(s.estado_suscripcion) && s.frecuencia_pago?.toUpperCase() !== "ANUAL" && (
                            <button
                              type="button"
                              className="btn-icono btn-icono-pago-meses"
                              onClick={() => abrirModalPagoMeses(s)}
                              title="Adelantar pagos"
                            >
                              <FaMoneyBillWave size={14} />
                              <span className="icono-tooltip">Adelantar pagos</span>
                            </button>
                          )}

                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="sin-resultados">
                      <i className="fas fa-search mr-2" />
                      No se encontraron suscriptores
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* ── Paginación ── */}
          {totalPaginas > 1 && (
            <div className="fact-paginacion">
              <span className="fact-pag-info">
                Mostrando {indexInicio + 1}–{Math.min(indexFin, datosFiltrados.length)} de {datosFiltrados.length} suscriptores
              </span>
              <div className="paginacion-wrap">
                <button className="btn-pagina btn-pag-nav" disabled={paginaActual === 1} onClick={() => setPaginaActual(1)}>«</button>
                <button className="btn-pagina btn-pag-nav" disabled={paginaActual === 1} onClick={() => setPaginaActual(p => p - 1)}>‹</button>
                {rangoInicio > 1 && <span className="btn-pagina btn-pag-dots">…</span>}
                {paginasVisibles.map((n) => (
                  <button key={n} className={`btn-pagina ${paginaActual === n ? "activa" : ""}`} onClick={() => setPaginaActual(n)}>{n}</button>
                ))}
                {rangoFin < totalPaginas && <span className="btn-pagina btn-pag-dots">…</span>}
                <button className="btn-pagina btn-pag-nav" disabled={paginaActual === totalPaginas} onClick={() => setPaginaActual(p => p + 1)}>›</button>
                <button className="btn-pagina btn-pag-nav" disabled={paginaActual === totalPaginas} onClick={() => setPaginaActual(totalPaginas)}>»</button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Modal Detalle ── */}
      {modalDetalle && suscDetalleActivo && (
        <div className="modal-overlay" onClick={() => { setModalDetalle(false); cancelarEdicion(); cancelarFormBeneficiario(); }}>
          <div className="modal-benef" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <div>
                <h5 className="modal-title-custom">
                  {editMode ? <FaEdit style={{ marginRight: 8 }} /> : <FaEye style={{ marginRight: 8 }} />}
                  {editMode ? "Editar Suscriptor" : "Detalle del Suscriptor"}
                </h5>
                <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>{suscDetalleActivo.nombresApellidos}</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {!editMode && suscDetalleActivo.estado_suscripcion?.toUpperCase() === "FINALIZADA" && !tieneSuscripcionActiva(suscDetalleActivo.id_suscriptor) && (
                  <button
                    type="button"
                    className="btn-modal-cancelar"
                    style={{ background: "#1a56db", color: "#fff", borderColor: "#1a56db", padding: "6px 14px", fontSize: "0.8rem", whiteSpace: "nowrap" }}
                    onClick={() => {
                      setModalDetalle(false);
                      abrirModalFinalizar(suscDetalleActivo, { soloRenovar: true });
                    }}
                  >
                    <FaUndo size={12} style={{ marginRight: 6 }} />
                    Renovar suscripción
                  </button>
                )}
                {!editMode && (
                  <button className="btn-icono btn-icono-edit" onClick={abrirEdicion} title="Editar">
                    <FaEdit size={14} />
                  </button>
                )}
                <button className="modal-close" onClick={() => { setModalDetalle(false); cancelarEdicion(); cancelarFormBeneficiario(); }}><FaTimes size={14} /></button>
              </div>
            </div>
            <div className="modal-body-custom" style={{ padding: "1.2rem 1.5rem" }}>
              {editMode ? (
                <div className="detalle-grid">
                  <div className="detalle-item">
                    <label className="detalle-label">Nombres</label>
                    <input className="custom-input detalle-input" value={editData.nombres || ""} onChange={(e) => setEditData({ ...editData, nombres: e.target.value })} />
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Apellidos</label>
                    <input className="custom-input detalle-input" value={editData.apellidos || ""} onChange={(e) => setEditData({ ...editData, apellidos: e.target.value })} />
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Estado Civil</label>
                    <select className="custom-input detalle-input" value={editData.estado_civil || ""} onChange={(e) => setEditData({ ...editData, estado_civil: e.target.value })}>
                      <option value="">Seleccionar</option>
                      <option value="SOLTERO (A)">Soltero/a</option>
                      <option value="CASADO (A)">Casado/a</option>
                      <option value="UNION LIBRE">Unión Libre</option>
                      <option value="DIVORCIADO (A)">Divorciado/a</option>
                      <option value="VIUDO (A)">Viudo/a</option>
                    </select>
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Fecha de Nacimiento</label>
                    <input className="custom-input detalle-input" type="date" value={editData.fecha_nacimiento || ""} onChange={(e) => setEditData({ ...editData, fecha_nacimiento: e.target.value })} />
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Celular</label>
                    <input className="custom-input detalle-input" value={editData.celular || ""} onChange={(e) => setEditData({ ...editData, celular: e.target.value })} />
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Email</label>
                    <input className="custom-input detalle-input" type="email" value={editData.email || ""} onChange={(e) => setEditData({ ...editData, email: e.target.value })} />
                  </div>
                  <div className="detalle-item">
                    <label className="detalle-label">Medio de Contacto</label>
                    <select className="custom-input detalle-input" value={editData.medio_contacto || ""} onChange={(e) => setEditData({ ...editData, medio_contacto: e.target.value })}>
                      <option value="">Seleccionar</option>
                      <option value="WHATSAPP">WhatsApp</option>
                      <option value="LLAMADA">Llamada</option>
                      <option value="EMAIL">Email</option>
                      <option value="WHATSAPP|EMAIL">WhatsApp y Email</option>
                      <option value="LLAMADA|WHATSAPP">Llamada y WhatsApp</option>
                      <option value="LLAMADA|WHATSAPP|EMAIL">Todos</option>
                    </select>
                  </div>
                </div>
              ) : (
                <>
                  {/* Tabs */}
                  <div className="docs-tabs" style={{ padding: 0, marginBottom: 16 }}>
                    <button className={`docs-tab ${detalleTab === "info" ? "docs-tab-activo" : ""}`} onClick={() => setDetalleTab("info")}>
                      <FaEye style={{ marginRight: 6 }} /> Información
                    </button>
                    {esPlanIndividual(suscDetalleActivo.nombre_plan) && (
                      <button className={`docs-tab ${detalleTab === "acudiente" ? "docs-tab-activo" : ""}`} onClick={() => setDetalleTab("acudiente")}>
                        <FaUser style={{ marginRight: 6 }} /> Acudiente
                      </button>
                    )}
                    {esPlanFamiliar(suscDetalleActivo.nombre_plan) && (
                      <button className={`docs-tab ${detalleTab === "beneficiarios" ? "docs-tab-activo" : ""}`} onClick={() => setDetalleTab("beneficiarios")}>
                        <FaUserFriends style={{ marginRight: 6 }} /> Beneficiarios
                      </button>
                    )}
                    <button className={`docs-tab ${detalleTab === "documentos" ? "docs-tab-activo" : ""}`} onClick={() => setDetalleTab("documentos")}>
                      <FaFileAlt style={{ marginRight: 6 }} /> Documentos
                    </button>
                    <button className={`docs-tab ${detalleTab === "contrato" ? "docs-tab-activo" : ""}`} onClick={() => setDetalleTab("contrato")}>
                      <FaFileContract style={{ marginRight: 6 }} /> Contrato
                    </button>
                  </div>

                  {/* Contenido según tab */}
                  {detalleTab === "info" && (
                    <div className="detalle-grid">
                      <h5 className="detalle-section-title"><FaIdCard style={{ marginRight: 6 }} />Datos Personales</h5>
                      <div className="detalle-item">
                        <span className="detalle-label">Documento</span>
                        <span className="detalle-valor">{suscDetalleActivo.documento}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Nombres</span>
                        <span className="detalle-valor">{suscDetalleActivo.nombresApellidos}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Estado Civil</span>
                        <span className="detalle-valor">{suscDetalleActivo.estado_civil || "—"}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Celular</span>
                        <span className="detalle-valor">{suscDetalleActivo.celular}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Email</span>
                        <span className="detalle-valor">{suscDetalleActivo.email || "—"}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Fecha Nac.</span>
                        <span className="detalle-valor">
                          {suscDetalleActivo.fecha_nacimiento && !esFechaInvalida(suscDetalleActivo.fecha_nacimiento)
                            ? `${parsearFechaLocal(suscDetalleActivo.fecha_nacimiento).toLocaleDateString("es-CO")} (${calcularEdad(suscDetalleActivo.fecha_nacimiento)} años)`
                            : "—"}
                        </span>
                      </div>

                      <h5 className="detalle-section-title"><FaFileAlt style={{ marginRight: 6 }} />Datos del Plan</h5>
                      <div className="detalle-item">
                        <span className="detalle-label">Plan</span>
                        <span className="detalle-valor">{suscDetalleActivo.nombre_plan}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Cód. Asesor</span>
                        <span className="detalle-valor">{suscDetalleActivo.codigo_asesor || "—"}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Frecuencia</span>
                        <span className={`badge-frecuencia-tag ${badgeFrecuencia(suscDetalleActivo.frecuencia_pago)}`}>
                          {suscDetalleActivo.frecuencia_pago}
                        </span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Nómina</span>
                        <span className="detalle-valor">{suscDetalleActivo.nomina || "NO"}</span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Estado Susc.</span>
                        <span className={`badge-estado ${badgeEstado(suscDetalleActivo.estado_suscripcion)}`}>
                          <span className="badge-dot" />{suscDetalleActivo.estado_suscripcion}
                        </span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Inicio Cob.</span>
                        <span className="detalle-valor">
                          {suscDetalleActivo.fecha_inicio_cobertura
                            ? parsearFechaLocal(suscDetalleActivo.fecha_inicio_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
                            : "—"}
                        </span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Fin Cob.</span>
                        <span className="detalle-valor">
                          {suscDetalleActivo.fecha_fin_cobertura
                            ? parsearFechaLocal(suscDetalleActivo.fecha_fin_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
                            : "—"}
                        </span>
                      </div>
                      <div className="detalle-item">
                        <span className="detalle-label">Primer Pago</span>
                        <span className="detalle-valor">
                          {suscDetalleActivo.primer_pago
                            ? parsearFechaLocal(suscDetalleActivo.primer_pago).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
                            : "—"}
                        </span>
                      </div>
                    </div>
                  )}

                  {detalleTab === "acudiente" && (
                    <div className="acudiente-section">
                      <h5 className="detalle-section-title"><FaUser style={{ marginRight: 6 }} />Acudiente</h5>
                      {loadingAcudiente ? (
                        <div className="sin-resultados"><i className="fas fa-spinner fa-spin mr-2" /> Cargando...</div>
                      ) : acudientes.length === 0 ? (
                        <div className="sin-resultados">No hay acudiente registrado.</div>
                      ) : (
                        <table className="usuarios-table benef-table" style={{ marginTop: 8 }}>
                          <thead>
                            <tr>
                              <th>Nombre</th><th>Parentesco</th><th>Celular</th><th>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {acudientes.map((a, idx) => (
                              <tr key={a.suscriptor_id || idx}>
                                <td><span className="suscriptor-nombre">{a.nombre}</span></td>
                                <td><span className="badge-parentesco badge-acudiente">{a.parentesco}</span></td>
                                <td className="td-secondary">{a.celular || "—"}</td>
                                <td><span className="suscriptor-email">{a.email || "—"}</span></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {detalleTab === "beneficiarios" && (
                    <div className="acudiente-section">
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                        <h5 className="detalle-section-title" style={{ margin: 0 }}>
                          <FaUserFriends style={{ marginRight: 6 }} />Beneficiarios ({beneficiariosActivos.length}/3)
                        </h5>
                        <button
                          className="btn-modal-guardar"
                          onClick={abrirAgregarBeneficiario}
                          disabled={!puedeAgregarBeneficiario}
                          title={puedeAgregarBeneficiario ? "Agregar beneficiario" : "Plan completo (3/3). Inactiva uno para liberar cupo."}
                        >
                          <FaUserPlus style={{ marginRight: 6 }} /> Agregar beneficiario
                        </button>
                      </div>

                      {benefFormMode && (
                        <div className="detalle-grid" style={{ marginBottom: 16, padding: 12, border: "1px solid #e5e7eb", borderRadius: 8 }}>
                          <div className="detalle-item">
                            <label className="detalle-label">Tipo Documento</label>
                            <select
                              className="custom-input detalle-input"
                              value={benefFormData.tipo_documento || ""}
                              disabled={benefFormMode !== "crear"}
                              onChange={(e) => setBenefFormData({ ...benefFormData, tipo_documento: e.target.value })}
                            >
                              <option value="CC">Cédula de Ciudadanía</option>
                              <option value="CE">Cédula de Extranjería</option>
                              <option value="TI">Tarjeta de Identidad</option>
                              <option value="RC">Registro Civil</option>
                              <option value="PA">Pasaporte</option>
                            </select>
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Número Documento</label>
                            <input
                              className="custom-input detalle-input"
                              value={benefFormData.numero_documento || ""}
                              disabled={benefFormMode !== "crear"}
                              onChange={(e) => setBenefFormData({ ...benefFormData, numero_documento: e.target.value })}
                            />
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Nombres</label>
                            <input className="custom-input detalle-input" value={benefFormData.nombres || ""} onChange={(e) => setBenefFormData({ ...benefFormData, nombres: e.target.value })} />
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Apellidos</label>
                            <input className="custom-input detalle-input" value={benefFormData.apellidos || ""} onChange={(e) => setBenefFormData({ ...benefFormData, apellidos: e.target.value })} />
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Teléfono</label>
                            <input className="custom-input detalle-input" value={benefFormData.telefono || ""} onChange={(e) => setBenefFormData({ ...benefFormData, telefono: e.target.value })} />
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Parentesco</label>
                            <select className="custom-input detalle-input" value={benefFormData.parentesco || ""} onChange={(e) => setBenefFormData({ ...benefFormData, parentesco: e.target.value })}>
                              <option value="" disabled>Seleccionar</option>
                              <option value="PADRE">Padre</option>
                              <option value="MADRE">Madre</option>
                              <option value="HIJO">Hijo</option>
                              <option value="HIJA">Hija</option>
                              <option value="CONYUGE">Cónyuge</option>
                              <option value="HERMANO">Hermano</option>
                              <option value="HERMANA">Hermana</option>
                              <option value="OTRO">Otro</option>
                            </select>
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Email</label>
                            <input className="custom-input detalle-input" type="email" value={benefFormData.email || ""} onChange={(e) => setBenefFormData({ ...benefFormData, email: e.target.value })} />
                          </div>
                          <div className="detalle-item">
                            <label className="detalle-label">Fecha de Nacimiento</label>
                            <input className="custom-input detalle-input" type="date" value={benefFormData.fecha_nacimiento || ""} onChange={(e) => setBenefFormData({ ...benefFormData, fecha_nacimiento: e.target.value })} />
                          </div>
                          <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 8 }}>
                            <button className="btn-modal-cancelar" onClick={cancelarFormBeneficiario} disabled={savingBenef}>Cancelar</button>
                            <button className="btn-modal-guardar" onClick={guardarBeneficiario} disabled={savingBenef}>
                              {savingBenef ? <><i className="fas fa-spinner fa-spin mr-2" /> Guardando...</> : <><FaSave style={{ marginRight: 6 }} /> Guardar</>}
                            </button>
                          </div>
                        </div>
                      )}

                      {loadingBenef ? (
                        <div className="sin-resultados"><i className="fas fa-spinner fa-spin mr-2" /> Cargando...</div>
                      ) : beneficiarios.length === 0 ? (
                        <div className="sin-resultados">No hay beneficiarios registrados.</div>
                      ) : (
                        <table className="usuarios-table benef-table" style={{ marginTop: 8 }}>
                          <thead>
                            <tr>
                              <th>#</th><th>Documento</th><th>Nombres</th><th>Email</th><th>Teléfono</th><th>Parentesco</th><th>Estado</th><th className="col-gmf">Citas GMF</th><th className="col-gmf">Desc. GMF</th><th className="col-acciones">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {beneficiarios.map((b, idx) => (
                              <tr key={b.id_beneficiario} className={benefFormMode === b.id_beneficiario ? "row-editando-benef" : ""}>
                                <td className="td-id">{idx + 1}</td>
                                <td>
                                  <span className="suscriptor-documento">
                                    <FaIdCard size={11} style={{ marginRight: 4, opacity: 0.6 }} />
                                    {b.tipo_documento} {b.numero_documento}
                                  </span>
                                </td>
                                <td><span className="suscriptor-nombre">{[b.nombres, b.apellidos].filter(Boolean).join(" ")}</span></td>
                                <td><span className="suscriptor-email" title={b.email || ""}>{b.email || "—"}</span></td>
                                <td className="td-secondary">{b.telefono || "—"}</td>
                                <td>
                                  <span className={`badge-parentesco ${b.parentesco?.toLowerCase() === "titular" ? "badge-titular" : "badge-familiar"}`}>
                                    {b.parentesco}
                                  </span>
                                </td>
                                <td>
                                  <span className={`badge-estado ${b.estado === "ACTIVO" ? "badge-activo" : "badge-inactivo"}`}>
                                    <span className="badge-dot" />{b.estado}
                                  </span>
                                </td>
                                <td className="td-secondary col-gmf">
                                  {!b.paciente_id ? "—" : consumosGMF[b.id_beneficiario]?.loading ? (
                                    <i className="fas fa-spinner fa-spin" />
                                  ) : consumosGMF[b.id_beneficiario]?.error ? (
                                    <span style={{ color: "#dc3545" }} title="No se pudo consultar SiiClinic">Error</span>
                                  ) : (
                                    consumosGMF[b.id_beneficiario]?.citasConTarjetaGMF ?? "—"
                                  )}
                                </td>
                                <td className="td-secondary col-gmf">
                                  {!b.paciente_id ? "—" : consumosGMF[b.id_beneficiario]?.loading ? (
                                    <i className="fas fa-spinner fa-spin" />
                                  ) : consumosGMF[b.id_beneficiario]?.error ? (
                                    <span style={{ color: "#dc3545" }} title="No se pudo consultar SiiClinic">Error</span>
                                  ) : (
                                    consumosGMF[b.id_beneficiario]?.beneficiosDescuentosGMF ?? "—"
                                  )}
                                </td>
                                <td className="col-acciones">
                                  {b.parentesco?.toLowerCase() !== "titular" && (
                                    <div style={{ display: "flex", gap: 6 }}>
                                      {b.estado === "ACTIVO" ? (
                                        <>
                                          <button className="btn-icono btn-icono-edit" onClick={() => abrirEdicionBeneficiario(b)} title="Editar">
                                            <FaEdit size={13} />
                                          </button>
                                          <button className="btn-icono btn-icono-inactivar" onClick={() => inactivarBeneficiario(b)} title="Inactivar">
                                            <FaBan size={13} />
                                          </button>
                                        </>
                                      ) : (
                                        <button
                                          className="btn-icono btn-icono-benef"
                                          onClick={() => activarBeneficiario(b)}
                                          title={puedeAgregarBeneficiario ? "Activar" : "Plan completo (3/3). Inactiva otro para liberar cupo."}
                                        >
                                          <FaUndo size={13} />
                                        </button>
                                      )}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {detalleTab === "documentos" && (
                    <div className="acudiente-section">
                      <h5 className="detalle-section-title"><FaFileAlt style={{ marginRight: 6 }} />Documentos</h5>
                      {loadingDocs ? (
                        <div className="sin-resultados"><i className="fas fa-spinner fa-spin mr-2" /> Cargando documentos...</div>
                      ) : documentos.length === 0 ? (
                        <div className="sin-resultados">No hay documentos cargados.</div>
                      ) : (
                        <table className="usuarios-table benef-table" style={{ marginTop: 8 }}>
                          <thead>
                            <tr>
                              <th>#</th><th>Nombre archivo</th><th>Fecha carga</th><th>Estado</th><th>Ver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {documentos.map((d, idx) => {
                              const partes = (d.url_documento || "").split("/");
                              const nombreRaw = partes[partes.length - 1] || "documento";
                              const nombreArchivo = nombreRaw.replace(/_[a-f0-9]{32}(\.[^.]+)$/, "$1");
                              const urlDescarga = d.id_documento
                                ? `${process.env.REACT_APP_API_BASE_URL}/api/Suscriptores/DescargarDocumento?id_documento=${d.id_documento}`
                                : null;
                              return (
                                <tr key={d.id_documento || idx}>
                                  <td className="td-id">{idx + 1}</td>
                                  <td>
                                    <span className="suscriptor-nombre" title={d.url_documento}>
                                      <FaFileAlt size={11} style={{ marginRight: 5, opacity: 0.5 }} />
                                      {nombreArchivo}
                                    </span>
                                  </td>
                                  <td className="td-secondary">
                                    {d.fecha_registro
                                      ? parsearFechaLocal(d.fecha_registro).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })
                                      : "—"}
                                  </td>
                                  <td>
                                    <span className={`badge-estado ${d.estado === "ACTIVO" ? "badge-activo" : "badge-inactivo"}`}>
                                      <span className="badge-dot" />{d.estado}
                                    </span>
                                  </td>
                                  <td>
                                    {urlDescarga ? (
                                      <button onClick={() => descargarArchivo(urlDescarga)} className="btn-ver-doc-link">
                                        <FaFileAlt size={11} /> Ver
                                      </button>
                                    ) : (
                                      <span className="td-secondary">Sin URL</span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {detalleTab === "contrato" && (
                    <div className="acudiente-section">
                      <h5 className="detalle-section-title"><FaFileContract style={{ marginRight: 6 }} />Contrato</h5>
                      {(() => {
                        const contrato = suscDetalleActivo.contrato;
                        if (!contrato || contrato === "No Enviado") {
                          return (
                            <div className="sin-resultados" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, padding: "20px 0" }}>
                              <FaFileContract size={40} style={{ color: "#cbd5e1" }} />
                              <span>El contrato aún no ha sido enviado.</span>
                            </div>
                          );
                        }
                        if (contrato === "Enviado pero no firmado") {
                          const reenviarContrato = async () => {
                            try {
                              const confirm = await Swal.fire({
                                title: "Reenviar contrato",
                                html: `<p>Se enviará el contrato a <b>${suscDetalleActivo.email}</b></p>`,
                                icon: "question",
                                showCancelButton: true,
                                confirmButtonText: "Sí, reenviar",
                                cancelButtonText: "Cancelar",
                                confirmButtonColor: "#1a56db",
                              });
                              if (!confirm.isConfirmed) return;
                              await axios.post(`${API}/EnviarCorreoContrato`, {
                                correo: suscDetalleActivo.email,
                                nombrePlan: suscDetalleActivo.nombre_plan,
                                nombreTitular: suscDetalleActivo.nombresApellidos,
                                nroDocumento: suscDetalleActivo.documento,
                                token: suscDetalleActivo.token_contrato,
                              });
                              Swal.fire({ toast: true, position: "top-end", icon: "success", title: "Contrato reenviado", showConfirmButton: false, timer: 3000, timerProgressBar: true });
                            } catch (err) {
                              Swal.fire({ icon: "error", title: "Error", text: err.response?.data?.mensaje || "No se pudo reenviar el contrato." });
                            }
                          };
                          return (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14, padding: "20px 0" }}>
                              <FaFileContract size={40} style={{ color: "#fbbf24" }} />
                              <span style={{ color: "#92400e", fontSize: "0.92rem", fontWeight: 500 }}>El contrato ha sido enviado pero aún no ha sido firmado.</span>
                              <button onClick={reenviarContrato} className="btn-modal-guardar">
                                <FaFileContract style={{ marginRight: 6 }} /> Reenviar contrato
                              </button>
                            </div>
                          );
                        }
                        if (contrato === "Enviado") {
                          return (
                            <div className="sin-resultados" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, padding: "20px 0" }}>
                              <FaFileContract size={40} style={{ color: "#fbbf24" }} />
                              <span>El contrato ha sido enviado pero aún no ha sido firmado.</span>
                            </div>
                          );
                        }
                        const urlContrato = `${baseURL}/api/Suscriptores/DescargarContrato?ruta=${encodeURIComponent(contrato)}`;
                        return (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, padding: "20px 0" }}>
                            <FaFileContract size={48} style={{ color: "#28a745" }} />
                            <span style={{ fontWeight: 600, color: "#155724", fontSize: "0.95rem" }}>Contrato firmado</span>
                            <button onClick={() => descargarArchivo(urlContrato)} className="btn-ver-doc-link" style={{ padding: "10px 24px", fontSize: "0.9rem" }}>
                              <FaFileContract style={{ marginRight: 6 }} /> Ver contrato
                            </button>
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="modal-footer-custom">
              {editMode ? (
                <>
                  <button className="btn-modal-cancelar" onClick={cancelarEdicion} disabled={saving}>Cancelar</button>
                  <button className="btn-modal-guardar" onClick={guardarEdicion} disabled={saving}>
                    {saving ? <><i className="fas fa-spinner fa-spin mr-2" /> Guardando...</> : <><FaSave style={{ marginRight: 6 }} /> Guardar</>}
                  </button>
                </>
              ) : (
                <button className="btn-modal-cancelar" onClick={() => setModalDetalle(false)}>Cerrar</button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Pagar N meses ── */}
      {modalPagoMeses && suscPagoMesesActivo && (
        <div className="modal-overlay" onClick={() => !procesandoPagoMeses && setModalPagoMeses(false)}>
          <div className="modal-benef modal-pago-meses" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <div>
                <h5 className="modal-title-custom">
                  <FaMoneyBillWave style={{ marginRight: 8 }} />
                  Registrar pago
                </h5>
                <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>{suscPagoMesesActivo.nombresApellidos}</span>
                <div style={{ fontSize: "0.78rem", opacity: 0.8, marginTop: 2 }}>Plan: <b>{suscPagoMesesActivo.nombre_plan}</b></div>
              </div>
              <button className="modal-close" onClick={() => !procesandoPagoMeses && setModalPagoMeses(false)}><FaTimes size={14} /></button>
            </div>
            <div className="modal-body-custom" style={{ padding: "1.2rem 1.5rem" }}>
              {loadingPagoMeses ? (
                <div className="sin-resultados"><i className="fas fa-spinner fa-spin mr-2" /> Cargando valor del plan...</div>
              ) : (
                <>
                  {!esSinPago(suscPagoMesesActivo.estado_suscripcion) && (
                    <>
                      {suscPagoMesesActivo.fecha_inicio_cobertura && suscPagoMesesActivo.fecha_fin_cobertura && (
                        <div style={{ fontSize: "0.82rem", color: "#374151", marginBottom: 4 }}>
                          Cobertura: <b>{parsearFechaLocal(suscPagoMesesActivo.fecha_inicio_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })}</b>
                          {" — "}
                          <b>{parsearFechaLocal(suscPagoMesesActivo.fecha_fin_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })}</b>
                        </div>
                      )}
                      <div style={{ fontSize: "0.82rem", color: "#374151", marginBottom: 12 }}>
                        Meses pagados: <b>{mesesYaPagados}</b>
                      </div>
                    </>
                  )}
                  <div className="detalle-item" style={{ marginBottom: 16 }}>
                    <label className="detalle-label">¿Cuántos meses va a pagar?</label>
                    {(12 - mesesYaPagados) > 0 ? (
                      <select
                        className="custom-input detalle-input"
                        value={mesesAPagar}
                        onChange={(e) => setMesesAPagar(Number(e.target.value))}
                      >
                        {Array.from({ length: 12 - mesesYaPagados }, (_, i) => i + 1).map((n) => (
                          <option key={n} value={n}>{n} {n === 1 ? "mes" : "meses"}</option>
                        ))}
                      </select>
                    ) : (
                      <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "8px 12px", fontSize: "0.82rem", color: "#991b1b" }}>
                        Ya se pagaron los 12 meses del año de cobertura vigente. No es posible registrar más pagos hasta el próximo periodo.
                      </div>
                    )}
                  </div>

                  {mesesAPagar === 12 && (
                    <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "8px 12px", marginBottom: 12, fontSize: "0.8rem", color: "#92400e" }}>
                      Para 12 meses se aplica el <b>valor anual del plan</b> (con descuento), no el precio mensual × 12.
                    </div>
                  )}

                  {(() => {
                    const formatoCOP = new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 });
                    const { diasProrrateo, montoProrrateo, montoMeses, montoTotal } = calcularDesglosePagoMeses();
                    return (
                      <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 10, padding: "12px 20px", marginBottom: 16 }}>
                        {diasProrrateo > 0 && (
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", color: "#166534", marginBottom: 4 }}>
                            <span>Prorrateo ({diasProrrateo} días)</span>
                            <span>{formatoCOP.format(montoProrrateo)}</span>
                          </div>
                        )}
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", color: "#166534", marginBottom: 8 }}>
                          <span>{mesesAPagar} {mesesAPagar === 1 ? "mes" : "meses"}</span>
                          <span>{formatoCOP.format(montoMeses)}</span>
                        </div>
                        <div style={{ borderTop: "1px dashed #86efac", paddingTop: 8, textAlign: "center" }}>
                          <span style={{ fontSize: "0.78rem", color: "#166534", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Total a pagar</span>
                          <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#15803d" }}>
                            {formatoCOP.format(montoTotal)}
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  <div className="detalle-item">
                    <label className="detalle-label">Medio de pago</label>
                    <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                      <button
                        type="button"
                        className={`btn-modal-cancelar${medioPagoMeses === "EFECTIVO" ? " activa" : ""}`}
                        style={medioPagoMeses === "EFECTIVO" ? { background: "#15803d", color: "#fff", borderColor: "#15803d" } : {}}
                        onClick={() => setMedioPagoMeses("EFECTIVO")}
                      >
                        💰 Efectivo
                      </button>
                      {!esPorNomina(suscPagoMesesActivo) && (
                        <button
                          type="button"
                          className={`btn-modal-cancelar${medioPagoMeses === "LINK" ? " activa" : ""}`}
                          style={medioPagoMeses === "LINK" ? { background: "#1a56db", color: "#fff", borderColor: "#1a56db" } : {}}
                          onClick={() => setMedioPagoMeses("LINK")}
                        >
                          🔗 Link de pasarela
                        </button>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer-custom">
              <button className="btn-modal-cancelar" onClick={() => setModalPagoMeses(false)} disabled={procesandoPagoMeses}>Cancelar</button>
              <button className="btn-modal-guardar" onClick={confirmarPagoMeses} disabled={loadingPagoMeses || procesandoPagoMeses || (12 - mesesYaPagados) <= 0}>
                {procesandoPagoMeses ? <><i className="fas fa-spinner fa-spin mr-2" /> Procesando...</> : "Confirmar pago"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal Finalizar / Renovar suscripción ── */}
      {modalFinalizar && suscFinalizarActivo && (
        <div className="modal-overlay" onClick={() => !procesandoFinalizar && setModalFinalizar(false)}>
          <div className="modal-benef modal-finalizar-suscripcion" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <div>
                <h5 className="modal-title-custom">
                  {soloRenovar ? <FaUndo style={{ marginRight: 8 }} /> : <FaBan style={{ marginRight: 8 }} />}
                  {soloRenovar ? "Renovar suscripción" : "Finalizar suscripción"}
                </h5>
                <span style={{ fontSize: "0.85rem", opacity: 0.85 }}>{suscFinalizarActivo.nombresApellidos}</span>
                <div style={{ fontSize: "0.78rem", opacity: 0.8, marginTop: 2 }}>{suscFinalizarActivo.documento}</div>
              </div>
              <button className="modal-close" onClick={() => !procesandoFinalizar && setModalFinalizar(false)}><FaTimes size={14} /></button>
            </div>
            <div className="modal-body-custom" style={{ padding: "1.4rem 1.8rem" }}>

              {/* ── Sección 1: plan actual ── */}
              <h5 className="detalle-section-title"><FaFileAlt style={{ marginRight: 6 }} />Suscripción actual</h5>
              <div style={{ display: "flex", gap: 20 }}>
                <div className="detalle-item" style={{ flex: 2 }}>
                  <span className="detalle-label">Plan</span>
                  <span className="detalle-valor">{suscFinalizarActivo.nombre_plan}</span>
                </div>
                <div className="detalle-item" style={{ flex: 1 }}>
                  <span className="detalle-label">Frecuencia</span>
                  <span className={`badge-frecuencia-tag ${badgeFrecuencia(suscFinalizarActivo.frecuencia_pago)}`}>
                    {suscFinalizarActivo.frecuencia_pago}
                  </span>
                </div>
              </div>
              {suscFinalizarActivo.fecha_inicio_cobertura && suscFinalizarActivo.fecha_fin_cobertura && (
                <div className="detalle-item">
                  <span className="detalle-label">Cobertura</span>
                  <span className="detalle-valor">
                    {parsearFechaLocal(suscFinalizarActivo.fecha_inicio_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })}
                    {" — "}
                    {parsearFechaLocal(suscFinalizarActivo.fecha_fin_cobertura).toLocaleDateString("es-CO", { day: "2-digit", month: "short", year: "numeric" })}
                  </span>
                </div>
              )}

              {!soloRenovar && (
                <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "10px 14px", margin: "14px 0 18px", fontSize: "0.82rem", color: "#92400e" }}>
                  Esta suscripción se marcará como <b>FINALIZADA</b>.
                </div>
              )}

              {/* ── Sección 2: ¿renovar? (se omite si ya se abrió en modo "solo renovar") ── */}
              {!soloRenovar && (
                <>
                  <h5 className="detalle-section-title" style={{ marginTop: 4 }}><FaUndo style={{ marginRight: 6 }} />¿Desea renovar la suscripción?</h5>
                  <div style={{ display: "flex", gap: 10, marginTop: 8, marginBottom: 6 }}>
                    <button
                      type="button"
                      className={`btn-modal-cancelar${deseaRenovar === true ? " activa" : ""}`}
                      style={{ flex: 1, ...(deseaRenovar === true ? { background: "#15803d", color: "#fff", borderColor: "#15803d" } : {}) }}
                      onClick={() => setDeseaRenovar(true)}
                    >
                      Sí, renovar
                    </button>
                    <button
                      type="button"
                      className={`btn-modal-cancelar${deseaRenovar === false ? " activa" : ""}`}
                      style={{ flex: 1, ...(deseaRenovar === false ? { background: "#dc3545", color: "#fff", borderColor: "#dc3545" } : {}) }}
                      onClick={() => setDeseaRenovar(false)}
                    >
                      No
                    </button>
                  </div>
                </>
              )}

              {/* ── Sección 3: datos de la renovación + cobro ── */}
              {deseaRenovar === true && (
                loadingFinalizar ? (
                  <div className="sin-resultados" style={{ marginTop: 12 }}><i className="fas fa-spinner fa-spin mr-2" /> Cargando valor del plan...</div>
                ) : (
                  <div style={{ borderTop: "1px dashed #e5e7eb", marginTop: 16, paddingTop: 16 }}>
                    <h5 className="detalle-section-title"><FaMoneyBillWave style={{ marginRight: 6 }} />Nueva suscripción</h5>

                    <div className="detalle-item">
                      <label className="detalle-label">Tipo de pago</label>
                      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                        <button
                          type="button"
                          className={`btn-modal-cancelar${frecuenciaRenovacion === "MENSUAL" ? " activa" : ""}`}
                          style={{ flex: 1, ...(frecuenciaRenovacion === "MENSUAL" ? { background: "#1a56db", color: "#fff", borderColor: "#1a56db" } : {}) }}
                          onClick={() => { setFrecuenciaRenovacion("MENSUAL"); setMesesRenovAPagar(1); }}
                        >
                          Mensual
                        </button>
                        <button
                          type="button"
                          className={`btn-modal-cancelar${frecuenciaRenovacion === "ANUAL" ? " activa" : ""}`}
                          style={{ flex: 1, ...(frecuenciaRenovacion === "ANUAL" ? { background: "#1a56db", color: "#fff", borderColor: "#1a56db" } : {}) }}
                          onClick={() => setFrecuenciaRenovacion("ANUAL")}
                        >
                          Anual
                        </button>
                      </div>
                    </div>

                    {frecuenciaRenovacion === "MENSUAL" && (
                      <div className="detalle-item" style={{ marginTop: 14 }}>
                        <label className="detalle-label">¿Cuántos meses va a pagar ahora?</label>
                        <select
                          className="custom-input detalle-input"
                          value={mesesRenovAPagar}
                          onChange={(e) => setMesesRenovAPagar(Number(e.target.value))}
                        >
                          {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
                            <option key={n} value={n}>{n} {n === 1 ? "mes" : "meses"}{n === 12 ? " (valor anual)" : ""}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="detalle-item" style={{ marginTop: 14 }}>
                      <label className="detalle-label">Medio de pago</label>
                      <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
                        <button
                          type="button"
                          className={`btn-modal-cancelar${medioPagoRenov === "EFECTIVO" ? " activa" : ""}`}
                          style={{ flex: 1, ...(medioPagoRenov === "EFECTIVO" ? { background: "#15803d", color: "#fff", borderColor: "#15803d" } : {}) }}
                          onClick={() => setMedioPagoRenov("EFECTIVO")}
                        >
                          💰 Efectivo
                        </button>
                        <button
                          type="button"
                          className={`btn-modal-cancelar${medioPagoRenov === "LINK" ? " activa" : ""}`}
                          style={{ flex: 1, ...(medioPagoRenov === "LINK" ? { background: "#1a56db", color: "#fff", borderColor: "#1a56db" } : {}) }}
                          onClick={() => setMedioPagoRenov("LINK")}
                        >
                          🔗 Link de pasarela
                        </button>
                      </div>
                    </div>

                    {(() => {
                      const formatoCOP = new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 });
                      const { diasProrrateo, montoProrrateo, montoMeses, montoTotal } = calcularDesglosePagoRenovacion();
                      const esAnual = frecuenciaRenovacion === "ANUAL" || mesesRenovAPagar === 12;
                      return (
                        <div style={{ background: "#f0fdf4", border: "1px solid #86efac", borderRadius: 10, padding: "12px 20px", marginTop: 16 }}>
                          {!esAnual && diasProrrateo > 0 && (
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", color: "#166534", marginBottom: 4 }}>
                              <span>Prorrateo ({diasProrrateo} días)</span>
                              <span>{formatoCOP.format(montoProrrateo)}</span>
                            </div>
                          )}
                          {!esAnual && (
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.82rem", color: "#166534", marginBottom: 8 }}>
                              <span>{mesesRenovAPagar} {mesesRenovAPagar === 1 ? "mes" : "meses"}</span>
                              <span>{formatoCOP.format(montoMeses)}</span>
                            </div>
                          )}
                          <div style={{ borderTop: !esAnual ? "1px dashed #86efac" : "none", paddingTop: !esAnual ? 8 : 0, textAlign: "center" }}>
                            <span style={{ fontSize: "0.78rem", color: "#166534", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                              {esAnual ? "Valor del año" : "Total a pagar"}
                            </span>
                            <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#15803d" }}>{formatoCOP.format(montoTotal)}</div>
                          </div>
                        </div>
                      );
                    })()}

                    <div style={{ fontSize: "0.78rem", color: "#6b7280", marginTop: 10 }}>
                      {medioPagoRenov === "LINK"
                        ? "Se generará un link de pago para que el titular complete el cobro; la suscripción queda SIN PAGO hasta que se confirme el pago."
                        : "El cobro se registrará de inmediato y la suscripción quedará activa."}
                    </div>
                  </div>
                )
              )}
            </div>
            <div className="modal-footer-custom">
              <button className="btn-modal-cancelar" onClick={() => setModalFinalizar(false)} disabled={procesandoFinalizar}>Cancelar</button>
              <button className="btn-modal-guardar" onClick={confirmarFinalizar} disabled={deseaRenovar === null || loadingFinalizar || procesandoFinalizar}>
                {procesandoFinalizar
                  ? <><i className="fas fa-spinner fa-spin mr-2" /> Procesando...</>
                  : (soloRenovar ? "Renovar suscripción" : (deseaRenovar ? "Finalizar y renovar" : "Finalizar"))}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalCitasGmf && suscCitasGmfActivo && (
        <div className="modal-overlay" onClick={() => setModalCitasGmf(false)}>
          <div className="modal-benef modal-citas-gmf" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <div>
                <h5 className="modal-title-custom"><FaCalendarCheck style={{ marginRight: 8 }} />Citas Consumidas</h5>
                <span style={{ fontSize: "0.8rem", opacity: 0.8 }}>{suscCitasGmfActivo.nombresApellidos}</span>
              </div>
              <button className="modal-close" onClick={() => setModalCitasGmf(false)}><FaTimes size={14} /></button>
            </div>
            <div className="modal-body-custom" style={{ padding: "1.2rem 1.5rem" }}>
              {loadingCitasGmf ? (
                <div className="sin-resultados"><i className="fas fa-spinner fa-spin mr-2" /> Consultando citas...</div>
              ) : (
                <>
                  {conteoCitasGmf?.error ? (
                    <div className="sin-resultados" style={{ marginBottom: 20 }}>No se pudo consultar el resumen de citas.</div>
                  ) : (
                    <div className="citas-gmf-resumen">
                      <div className="citas-gmf-card citas-gmf-card-hemograma">
                        <div className="citas-gmf-card-valor">{conteoCitasGmf?.consumidoH ?? 0} / {conteoCitasGmf?.maxHemograma ?? 0}</div>
                        <div className="citas-gmf-card-label">Hemograma</div>
                      </div>
                      <div className="citas-gmf-card citas-gmf-card-general">
                        <div className="citas-gmf-card-valor">{conteoCitasGmf?.consumidoG ?? 0} / {conteoCitasGmf?.maxGeneral ?? 0}</div>
                        <div className="citas-gmf-card-label">Medicina General</div>
                      </div>
                      <div className="citas-gmf-card citas-gmf-card-especialidades">
                        <div className="citas-gmf-card-valor">{conteoCitasGmf?.consumidoE ?? 0} / {conteoCitasGmf?.maxEspecialidades ?? 0}</div>
                        <div className="citas-gmf-card-label">Especialidades</div>
                      </div>
                    </div>
                  )}

                  {citasGmfDetalle?.error ? (
                    <div className="sin-resultados">No se pudo consultar el detalle de citas.</div>
                  ) : (
                    <>
                      {renderTablaCitasGmf("Citas con Tarjeta GMF", (citasGmfDetalle || []).filter((c) => c.tipoMembresia?.toUpperCase() === "TARJETA GMF"))}
                      {renderTablaCitasGmf("Citas con Descuento GMF", (citasGmfDetalle || []).filter((c) => c.tipoMembresia?.toUpperCase() === "TARJETA GMF DESCUENTO"))}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Suscriptores;
